import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {imagesRegister} from "../../services/imagesRegister";
import {userRegister} from "../../services/userRegister";
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {quotesRegister} from "../../services/quotesRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import TiktokPixel from 'tiktok-pixel';
import SnapchatPixel from 'react-snapchat-pixel';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {industriesRegister} from "../../services/industriesRegister";
import {scraperRegister} from "../../services/scraperRegister";
import Typist from "react-typist";
import BoosterHeader from "../../components/booster-header/component";
import BoosterHeaderBranding from "../../components/booster-header-branding/component";
import queryString from "query-string";
import Carousel from 're-carousel';
import AliceCarousel from 'react-alice-carousel';
import "react-alice-carousel/lib/alice-carousel.css";
import Slider, {Range} from 'rc-slider';
import Tooltip from 'rc-tooltip';
import 'rc-slider/assets/index.css';
import BoosterProperty from "../../components/booster-property/component";
import BoosterFeatured from "../../components/booster-featured/component";
import Footer from "../../components/footer/component";
import {scroller, Element} from 'react-scroll'
import * as moment from 'moment'
import Dropdown from "../../components/dropdown/component";
//needed for async functions inside TikTok pixel
import "regenerator-runtime/runtime";

const Handle = Slider.Handle;

class BoosterList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            format_small: false,
            first_drag: true,
            tab: "standard",
            min_months: 1,
            max_months: 8,
            months: 3,
            leads: 0,
            spend_ae_en: {
                options: [
                    {id: 1, title: 'AED 5 K', spend: 5000},
                    {id: 2, title: 'AED 15 K', spend: 15000},
                    {id: 3, title: 'AED 30 K', spend: 30000},
                    {id: 4, title: 'AED 50 K', spend: 50000},
                    {id: 5, title: 'AED 100 K', spend: 100000}
                ],
                placeholder: "Your monthly spend",
                value: JSON.stringify({id: 1, title: 'AED 5 K', spend: 5000}),
                error: false
            },
            spend_se_sv: {
                options: [
                    {id: 1, title: '5 T SEK', spend: 5000},
                    {id: 2, title: '15 T SEK', spend: 15000},
                    {id: 3, title: '30 T SEK', spend: 30000},
                    {id: 4, title: '50 T SEK', spend: 50000},
                    {id: 5, title: '100 T SEK', spend: 100000}
                ],
                placeholder: "Din månadsbudget",
                value: JSON.stringify({id: 1, title: '5 T SEK', spend: 5000}),
                error: false
            },
            spend_se_en: {
                options: [
                    {id: 1, title: 'SEK 5 K', spend: 5000},
                    {id: 2, title: 'SEK 15 K', spend: 15000},
                    {id: 3, title: 'SEK 30 K', spend: 30000},
                    {id: 4, title: 'SEK 50 K', spend: 50000},
                    {id: 5, title: 'SEK 100 K', spend: 100000}
                ],
                placeholder: "Your monthly spend",
                value: JSON.stringify({id: 1, title: 'SEK 5 K', spend: 5000}),
                error: false
            },
            rates: [],
            rates_data: [],
            override_teaser: false,
            search: "",
            from_channel: "",
            click_id: ["",""],
            feed_id: "",
            check_freetext: false,
            isLoading: true,
            error: false,
            isLoadingReseller: true,
            errorReseller: false,
            brandingSuccess: false,
            new: false,
            open: false,
            verified_link: null,
            sort_value: JSON.stringify({title: 'Newest', value: 'date', option: false, selected: true}),
            sort_value_sv: JSON.stringify({title: 'Nyaste', value: 'date', option: false, selected: true}),
            types: [
                {title: 'sales', selected: true},
                {title: 'rentals', selected: false},
                {title: 'ready', selected: false},
                {title: 'off-plans', selected: false},
                {title: 'upcoming', selected: false}
                //{title: 'investments', selected: false}
            ],
            types_sv: [
                {title: 'köpa', selected: true},
                {title: 'hyra', selected: false},
                {title: 'klara', selected: false},
                {title: 'nyproduktion', selected: false},
                {title: 'kommande', selected: false}
                //{title: 'investments', selected: false}
            ],
            types_yl: [
                {title: 'all deals', selected: true},
                {title: '3y deals', selected: false},
                {title: '4y deals', selected: false},
                {title: '5y deals', selected: false},
                {title: '6y deals', selected: false},
                {title: '7y deals', selected: false}
                //{title: 'investments', selected: false}
            ],
            type_value: JSON.stringify({title: 'sales', selected: true}),
            type_value_sv: JSON.stringify({title: 'köpa', selected: true}),
            type_value_yl: JSON.stringify({title: 'all deals', selected: true}),
            listings_data: [],
            sort: [
                {title: 'Newest', value: 'date', option: false, selected: true},
                {title: 'Price (low)', value: 'price', option: true, selected: false},
                {title: 'Price (high)', value: 'price', option: false, selected: false},
                {title: 'Beds (low)', value: 'beds', option: true, selected: false},
                {title: 'Beds (high)', value: 'beds', option: false, selected: true}
            ],
            sort_sv: [
                {title: 'Nyaste', value: 'date', option: false, selected: true},
                {title: 'Pris (lågt)', value: 'price', option: true, selected: false},
                {title: 'Pris (högt)', value: 'price', option: false, selected: false},
                {title: 'Rum (lågt)', value: 'beds', option: true, selected: false},
                {title: 'Rum (högt)', value: 'beds', option: false, selected: true}
            ],
            sort_yl: [
                {title: 'Newest', value: 'date', option: false, selected: true},
                {title: 'Price (low)', value: 'price', option: true, selected: false},
                {title: 'Price (high)', value: 'price', option: false, selected: false},
                {title: 'Beds (low)', value: 'beds', option: true, selected: false},
                {title: 'Beds (high)', value: 'beds', option: false, selected: true},
                {title: 'Yield (low)', value: 'yield', option: true, selected: false},
                {title: 'Yield (high)', value: 'yield', option: false, selected: true}
            ],
            listings: [],
            default: [],
            featured: [],
            isLoadingFeatured: true,
            categories: {
                'sales': {
                    title: 'Latest for sale',
                    items: [],
                    loading: true
                },
                'rentals': {
                    title: 'Latest rentals',
                    items: [],
                    loading: true
                },
                'ready': {
                    title: 'Latest ready',
                    items: [],
                    loading: true
                },
                'offplan': {
                    title: 'Latest off-plans',
                    items: [],
                    loading: true
                },
                'new': {
                    title: 'Latest upcoming',
                    items: [],
                    loading: true
                }
                /*/
                'investment': {
                    title: 'Latest investments',
                    items: [],
                    loading: true
                }
                /*/
            },
            categories_sv: {
                'sales': {
                    title: 'Senaste till salu',
                    items: [],
                    loading: true
                },
                'rentals': {
                    title: 'Senaste att hyra',
                    items: [],
                    loading: true
                },
                'ready': {
                    title: 'Senaste klara',
                    items: [],
                    loading: true
                },
                'offplan': {
                    title: 'Senaste nyproduktion',
                    items: [],
                    loading: true
                },
                'new': {
                    title: 'Senaste kommande',
                    items: [],
                    loading: true
                }
                /*/
                'investment': {
                    title: 'Latest investments',
                    items: [],
                    loading: true
                }
                /*/
            },
            categories_yl: {
                'all': {
                    title: 'All latest deals',
                    items: [],
                    loading: true
                },
                '3y': {
                    title: 'Latest 3y deals',
                    items: [],
                    loading: true
                },
                '4y': {
                    title: 'Latest 4y deals',
                    items: [],
                    loading: true
                },
                '5y': {
                    title: 'Latest 5y deals',
                    items: [],
                    loading: true
                },
                '6y': {
                    title: 'Latest 6y deals',
                    items: [],
                    loading: true
                },
                '7y': {
                    title: 'Latest 7y deals',
                    items: [],
                    loading: true
                }
                /*/
                'investment': {
                    title: 'Latest investments',
                    items: [],
                    loading: true
                }
                /*/
            },
            category_value_ready: 'ready property',
            category_value_offplan: 'off-plan property',
            category_value_new: 'upcoming listing',
            category_value_ready_sv: 'inflyttningsklar',
            category_value_offplan_sv: 'nyproduktion',
            category_value_new_sv: 'kommande objekt',
            min_prices: [
                {price: 0, disabled: false},
                {price: 100000, disabled: false},
                {price: 200000, disabled: false},
                {price: 300000, disabled: false},
                {price: 400000, disabled: false},
                {price: 500000, disabled: false},
                {price: 600000, disabled: false},
                {price: 700000, disabled: false},
                {price: 800000, disabled: false},
                {price: 900000, disabled: false},
                {price: 1000000, disabled: false},
            ],
            max_prices: [
                {price: 0, disabled: false},
                {price: 100000, disabled: false},
                {price: 200000, disabled: false},
                {price: 300000, disabled: false},
                {price: 400000, disabled: false},
                {price: 500000, disabled: false},
                {price: 600000, disabled: false},
                {price: 700000, disabled: false},
                {price: 800000, disabled: false},
                {price: 900000, disabled: false},
                {price: 1000000, disabled: false},
            ],
            beds: {first: null, second: null},
            price: {first: 0, second: 0},
            base_currency: salesChannelRegister.get('currency').toUpperCase(),
            currency: "",
            price_range: [0, 0],
            min: 0,
            max: 0,
            page_size: 30,
            page: 1,
            min_price: 0,
            max_price: 0,
            beds_selected: false
        };
    };

    componentWillMount() {
        this.mounted = true;

        //RESET STORAGE
        cartRegister.remove();
        quotesRegister.remove();
        imagesRegister.remove();
        industriesRegister.remove();
        scraperRegister.remove();

        //SCROLL TOP
        window.scrollTo(0, 0);


        //SET STATE
        if (this.props.match.params.market === 'se' && this.props.match.params.lang === 'sv') {
            this.setState({
                sort: this.state.sort_sv,
                types: this.state.types_sv,
                sort_value: this.state.sort_value_sv,
                sort_value_revert: this.state.sort_value_sv,
                type_value: this.state.type_value_sv,
                categories: this.state.categories_sv,
                category_value_ready: this.state.category_value_ready_sv,
                category_value_offplan: this.state.category_value_offplan_sv,
                category_value_new: this.state.category_value_new_sv
            });
        } else if (this.props.match.params.market === 'se' && this.props.match.params.lang === 'en') {
            this.setState({
                category_value_ready: this.state.category_value_ready_sv,
                category_value_offplan: this.state.category_value_offplan_sv,
                category_value_new: this.state.category_value_new_sv
            });
        } else {
            this.setState({
                sort_value_revert: this.state.sort_value
            });
        }

        if ((this.renderYieldlock() || this.renderYieldspotter())) {
            this.setState({
                types: this.state.types_yl,
                type_value: this.state.type_value_yl,
                categories: this.state.categories_yl,
                sort: this.state.sort_yl
            });
        }

        //UPDATE FROM CHANNEL & CLICKID & FEEDID
        try {
            this.setState({
                from_channel: this._getFromChannel(),
                click_id: this._getClickId(),
                feed_id: this._getFeedId(),
                //check_freetext: this._checkFreetext(),
                check_freetext: this._checkMedialock(),
            });
        } catch (e) {
        }

        //UPDATE DATA
        this.setState({
            lang: this.props.match.params.lang,
            market: this.props.match.params.market
        }, () => {
            this.update.reseller();
            this.update.user();
            this.update.calculator();
            this.update.search();
            //this.update.query();
        });

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            if (this.renders.platformTeaser()) {
                ReactGA.pageview('/teaser');
                ReactGA4.send({ hitType: "pageview", page: "/teaser" });
            } else {
                ReactGA.pageview('/listings');
                ReactGA4.send({ hitType: "pageview", page: "/listings" });
            }
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }

    }

    componentWillUnmount() {
        this.mounted = false;
    }

    update = {
        tracking: () => {
            if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1" && !this.renders.platformTeaser()) {

                //TIKTOK PIXEL
                //currently advanced matching not available on portal
                //TODO: send data in url from landing or execute login
                //Currently no support for TikTok feeds on fallback feeds
                //TODO: Add TikTok to fallback feeds

                if (this.renderPropertyBooster()) {
                    TiktokPixel.init('CB9JOS3C77U9C04LEQI0');
                    // page view auto fired upon init
                    this.setState({
                        tiktok_init: true
                    });
                } else if (this.renderBoostaBostad()) {

                } else if (this.renderYieldlock()) {

                }

                if (this.state.brandingSuccess && this.state.tiktok_id_branding.length > 2) {
                    TiktokPixel.init(this.state.tiktok_id_branding);
                    // page view auto fired upon init
                    this.setState({
                        tiktok_init: true
                    });
                }

                //SNAPCHAT PIXEL
                //currently advanced matching not available on portal
                //TODO: send data in url from landing or execute login
                //Currently no support for Snapchat feeds on fallback feeds
                //TODO: Add Snapchat to fallback feeds

                if (this.renderPropertyBooster()) {
                    SnapchatPixel.init('ea40f2f2-52e4-4324-a278-3aa34ae0dd42');
                    this.setState({
                        snapchat_init: true
                    });
                } else if (this.renderBoostaBostad()) {

                } else if (this.renderYieldlock()) {

                }

                if (this.state.brandingSuccess && this.state.snapchat_id_branding.length > 2) {
                    SnapchatPixel.init(this.state.snapchat_id_branding);
                    this.setState({
                        snapchat_init: true
                    });
                }

                //Executes page view on both pixels (if applicable)
                SnapchatPixel.pageView();

                //GOOGLE ANALYTICS
                if (this.renderPropertyBooster()) {

                    ReactGA.initialize('UA-133715853-6');
                    ReactGA.pageview('/listings');

                    //This way both trackers (if branding exist) are triggered each event – not so good for dynamic remarketing as master feed don't include reseller listings and vice versa
                    //NOTE: GA4 don't offer to define trackers old GA way and dont let you define two instances of react-ga4 – PENDING SOLUTION
                    if (this.state.brandingSuccess && this.state.ga4_id_branding.length > 2) {
                        ReactGA4.initialize([
                            {
                                trackingId: 'G-XEMQL79M33',
                            },
                            {
                                trackingId: this.state.ga4_id_branding,
                            },
                        ]);
                    } else {
                        ReactGA4.initialize('G-XEMQL79M33');
                    }
                    ReactGA4.send({ hitType: "pageview", page: "/listings" });


                } else if (this.renderBoostaBostad()) {
                    ReactGA.initialize('UA-133715853-8');
                    ReactGA.pageview('/listings');

                    //This way both trackers (if branding exist) are triggered each event – not so good for dynamic remarketing as master feed don't include reseller listings and vice versa
                    //NOTE: GA4 don't offer to define trackers old GA way and dont let you define two instances of react-ga4 – PENDING SOLUTION
                    if (this.state.brandingSuccess && this.state.ga4_id_branding.length > 2) {
                        ReactGA4.initialize([
                            {
                                trackingId: 'G-K11N0RECN5',
                            },
                            {
                                trackingId: this.state.ga4_id_branding,
                            },
                        ]);
                    } else {
                        ReactGA4.initialize('G-K11N0RECN5');
                    }
                    ReactGA4.send({ hitType: "pageview", page: "/listings" });

                } else if (this.renderYieldlock() || this.renderYieldspotter()) {
                    ReactGA.initialize('UA-133715853-9');
                    ReactGA.pageview('/listings');

                    //WE DONT PROVIDE BRANDING FOR YIELDLOCK
                    ReactGA4.initialize('G-9G9SWZZ3GS');
                    ReactGA4.send({ hitType: "pageview", page: "/listings" });
                }

                if (this.state.brandingSuccess && this.state.ga_id_branding.length > 2) {
                    ReactGA.ga('create', this.state.ga_id_branding, 'auto', { 'name': 'reseller' });
                    ReactGA.ga('reseller.send', { hitType: 'pageview', page: '/listings' });
                }
                //Equivalent to above for GA4 defined inside initializer

                //FACEBOOK PIXEL

                if (this.state.brandingSuccess && this.state.fb_id_branding.length > 2) {
                    ReactPixel.init(this.state.fb_id_branding);
                }

                if (this.renderPropertyBooster()) {
                    ReactPixel.init('788655492072715');

                    //FIRES PAGE VIEW ON BOTH PIXELS
                    ReactPixel.pageView();

                } else if (this.renderBoostaBostad()) {
                    ReactPixel.init('3891711630936349');

                    //FIRES PAGE VIEW ON BOTH PIXELS
                    ReactPixel.pageView();

                } else if (this.renderYieldlock() || this.renderYieldspotter()) {
                    ReactPixel.init('788655492072715');

                    //FIRES PAGE VIEW ON BOTH PIXELS
                    ReactPixel.pageView();

                }
            }
        },
        currency: () => {
            try {
                let query = queryString.parse(this.props.location.search);
                if (query.currency) {
                    this.functions.setCurrency(query.currency.toUpperCase());
                } else {
                    this.functions.setCurrency(this.state.base_currency);
                }
            } catch (e) {
            }
        },
        rates: (base) => {
            console.log(base.toUpperCase());
            dataRegister.rates(base.toUpperCase()).then((response) => {
                try {
                    let rates = [];
                    Object.keys(response.rates).map((key) => {
                        rates.push(key);
                    });
                    this.setState({
                        rates: rates,
                        rates_data: response.rates
                    }, () => {
                        this.update.listings();
                    });
                } catch (e) {
                }
            })
        },
        user: () => {
            try {
                let user = userRegister.get();
                if (user) {
                    this.setState({
                        reseller: user.reseller,
                        inhouse: user.inhouse
                    });
                }
            } catch (error) {
            }
        },
        reseller: () => {
            let query = queryString.parse(this.props.location.search);
            if (query.id && !this.renders.platformTeaser() && !this.renderYieldlock() && !this.renderYieldspotter()) {
                try {
                        let user = query.id;
                        dataRegister.lookUpReseller(salesChannelRegister.get('market'), this.renders.saleschannel(), user).then((response) => {
                            if(!response.errors) {

                                this.setState({
                                    reseller_id: query.id,
                                });

                                try {
                                    if(response.logo_image){
                                        this.setState({
                                            reseller_logo: response.logo_image,
                                        });
                                    }
                                } catch (e) {}

                                try {
                                    if(response.branding_image){
                                        this.setState({
                                            reseller_banner: response.branding_image,
                                        });
                                    }
                                } catch (e) {}

                                try {
                                    if(response.favicon_image){
                                        this.setState({
                                            reseller_favicon: response.favicon_image,
                                        });
                                    }
                                } catch (e) {}

                                try {
                                    if(response.company_name){
                                        this.setState({
                                            reseller_name: response.company_name,
                                        });
                                    }
                                } catch (e) {}

                                try {
                                    if(response.website){
                                        this.setState({
                                            reseller_website: response.website,
                                        });
                                    }
                                } catch (e) {}

                                try {
                                    if(response.branding_pref){
                                        if(response.branding_pref.primary_color){
                                            this.setState({reseller_primary: response.branding_pref.primary_color});
                                        }
                                        if(response.branding_pref.secondary_color){
                                            this.setState({reseller_secondary: response.branding_pref.secondary_color});
                                        }
                                    }
                                } catch (e) {}

                                try {
                                    if(response.branding_pref){
                                        if(response.branding_pref.infobox_m || response.branding_pref.infobox_s){
                                            this.setState({format_small: true});
                                        }
                                    }
                                } catch (e) {}

                                try {
                                    if(response.socialData){
                                        if(response.socialData.fb_id_branding){
                                            this.setState({fb_id_branding: response.socialData.fb_id_branding});
                                        }
                                        if(response.socialData.ga_id_branding){
                                            this.setState({ga_id_branding: response.socialData.ga_id_branding});
                                        }
                                        if(response.socialData.ga4_id_branding){
                                            this.setState({ga4_id_branding: response.socialData.ga4_id_branding});
                                        }
                                        if(response.socialData.tiktok_id_branding){
                                            this.setState({tiktok_id_branding: response.socialData.tiktok_id_branding});
                                        } else {
                                            this.setState({tiktok_id_branding: ""});
                                        }
                                        if(response.socialData.snapchat_id_branding){
                                            this.setState({snapchat_id_branding: response.socialData.snapchat_id_branding});
                                        } else {
                                            this.setState({snapchat_id_branding: ""});
                                        }
                                        if(response.socialData.image){
                                            this.setState({reseller_background: response.socialData.image});
                                        }
                                    }
                                } catch (e) {}

                                try {
                                if (response.user_id && response.logo_image && response.branding_image && response.favicon_image && response.company_name && response.website && response.branding_pref && response.branding_pref.primary_color && response.branding_pref.secondary_color) {
                                    this.setState({brandingSuccess: true});
                                }
                                } catch (e) {
                                    this.setState({brandingSuccess: false});
                                }

                                this.setState({
                                    reseller_id: this.state.reseller_id,
                                    reseller_logo: this.state.reseller_logo,
                                    reseller_banner: this.state.reseller_banner,
                                    reseller_favicon: this.state.reseller_favicon,
                                    reseller_name: this.state.reseller_name,
                                    reseller_website: this.state.reseller_website,
                                    reseller_primary: this.state.reseller_primary,
                                    reseller_secondary: this.state.reseller_secondary,
                                    fb_id_branding: this.state.fb_id_branding,
                                    ga_id_branding: this.state.ga_id_branding,
                                    ga4_id_branding: this.state.ga4_id_branding,
                                    tiktok_id_branding: this.state.tiktok_id_branding,
                                    snapchat_id_branding: this.state.snapchat_id_branding,
                                    reseller_background: this.state.reseller_background,
                                    isLoadingReseller: false,
                                    errorReseller: false,
                                    brandingSuccess: this.state.brandingSuccess,
                                }, () => {
                                    this.update.currency();
                                });

                            } else {
                                this.setState({isLoadingReseller: false, errorReseller: true}, () => {
                                    this.update.currency();
                                });
                            }
                        }, (error) => {
                            this.setState({isLoadingReseller: false, errorReseller: true}, () => {
                                this.update.currency();
                            });
                        });
                } catch (error) {
                    this.setState({isLoadingReseller: false, errorReseller: true}, () => {
                        this.update.currency();
                    });
                }
            } else {
                this.update.currency();
            }
        },
        listings: () => {

            let user = false;
            if (this.state.brandingSuccess && this.state.reseller_id) {
                user = this.state.reseller_id;
            }

            try {
                dataRegister.getRelated(this.state.market, this.state.lang, this.renders.saleschannel(), user, 0, 0).then((response) => {

                    /*
                    // Old way to filter on agency
                    let data = [];
                    let all = [];

                    try {
                        for (let i = 0; i < response.length; i++) {
                            try {
                                response[i].data.date = moment(response[i].data.created_at).format('YYYYMMDD');
                            } catch (e) {
                            }
                            all.push(response[i]);
                            if (this.state.brandingSuccess) {
                                //Match only agency related
                                try {
                                    //console.log(response[i].data);
                                    let broker_email = response[i].data.landing_extra.broker.email;
                                    broker_email = broker_email.toLowerCase();
                                    if (broker_email.indexOf(this.state.reseller_website.toLowerCase()) !== -1) {
                                        data.push(response[i]);
                                    }
                                } catch (e) {
                                    console.log(e);
                                }
                            } else {
                                data.push(response[i]);
                            }
                        }
                    } catch (error) {
                        data = all;
                    }
                    //console.log(data);
                    //console.log(response);
                    */

                    this.setState({
                        listings_data: this.parsers.init(response)
                        //listings_data: this.parsers.init(data)
                    }, () => {

                        if ((this.renderYieldlock() || this.renderYieldspotter())) {
                            this.parsers.categories_yl(this.state.listings_data);
                            this.parsers.listings(this.state.listings_data);
                            this.parsers.types_yl(this.state.listings_data);
                        } else {
                            this.parsers.categories(this.state.listings_data);
                            this.parsers.listings(this.state.listings_data);
                            this.parsers.types(this.state.listings_data);
                            this.parsers.featured(this.state.listings_data);
                        }

                        this.update.query();


                        //load additional batch
                        /*

                        try {
                            dataRegister.getRelated(this.state.market, this.state.lang, this.renders.saleschannel(), user, 1, 100).then((response) => {

                                this.setState({
                                    listings_data: this.state.listings_data.concat(this.parsers.init(response))
                                    //listings_data: this.parsers.init(data)
                                }, () => {

                                    if ((this.renderYieldlock() || this.renderYieldspotter())) {
                                        this.parsers.categories_yl(this.state.listings_data);
                                        this.parsers.listings(this.state.listings_data);
                                        this.parsers.types_yl(this.state.listings_data);
                                    } else {
                                        this.parsers.categories(this.state.listings_data);
                                        this.parsers.listings(this.state.listings_data);
                                        this.parsers.types(this.state.listings_data);
                                        this.parsers.featured(this.state.listings_data);
                                    }


                                })
                            }, (error) => {
                                this.setState({error: true});
                            });
                        } catch (e) {
                            this.setState({error: true});
                        }

                       */

                    })
                }, (error) => {
                    this.setState({isLoading: false, error: true});
                });
            } catch (e) {
                this.setState({isLoading: false, error: true});
            }
        },
        query: () => {
            try {
                let query = queryString.parse(this.props.location.search);
                if (query.type) {
                    for (let i = 0; i < this.state.types.length; i++) {
                        if (query.type === this.state.types[i].title.replace(/\s/g, '')) {
                            this.functions.selectType(this.state.types[i]);
                        }
                    }
                }
                //this.setState({search: "villa"});
            } catch (e) {
            }
        },
        search: () => {
            try {
                let query = queryString.parse(this.props.location.search);
                if (query.freetext) {
                    this.setState({search: query.freetext});
                }
            } catch (e) {
            }
        },
        calculator: () => {
            try {
                let min_months = 1;
                let max_months = 8;
                let months = 3;
                this.setState({max_months: max_months, months: months, min_months: min_months});
            } catch (e) {
            }
        }
    };

    functions = {
        setCurrency: (item) => {
            this.setState({
                currency: item
            }, () => {
                console.log(item);
                this.update.tracking();
                this.update.rates(this.state.base_currency);
            });
        },
        selectType: (item) => {
            for (let i = 0; i < this.state.types.length; i++) {
                if (this.state.types[i].title === item.title) {
                    this.state.types[i].selected = true;
                } else {
                    this.state.types[i].selected = false;
                }
            }
            item.selected = true;
            this.setState({
                type_value: JSON.stringify(item),
                types: this.state.types,
                beds: {first: null, second: null},
                page: 1,
            }, () => {
                this.parsers.listings(this.state.listings_data);
            });
        },
        selectTypeMobile: (item) => {
            try {
                let item_parsed = JSON.parse(item);
                for (let i = 0; i < this.state.types.length; i++) {
                    if (this.state.types[i].title === item_parsed.title) {
                        this.state.types[i].selected = true;
                    } else {
                        this.state.types[i].selected = false;
                    }
                }
                item_parsed.selected = true;
                this.setState({
                    type_value: JSON.stringify(item_parsed),
                    types: this.state.types,
                    beds: {first: null, second: null},
                    page: 1,
                }, () => {
                    this.parsers.listings(this.state.listings_data);
                });
            } catch (e) {
            }
        },
        selectBeds: (item) => {
            if (!this.state.beds.first) {
                this.state.beds.first = item;
            } else if (this.state.beds.first && !this.state.beds.second && this.state.beds.first !== item) {
                this.state.beds.second = item;
            } else if (this.state.beds.first && !this.state.beds.second && this.state.beds.first === item) {
                this.state.beds.first = null;
                this.state.beds.second = null;
            } else {
                this.state.beds.first = item;
                this.state.beds.second = null;
            }
            this.setState({beds: this.state.beds, beds_selected: true}, () => {
                this.parsers.listings(this.state.listings_data);
            });
        },
        setMinPrice: (item) => {
            this.setState({min_price: item}, () => {
                try {
                    this.state.price_range[0] = JSON.parse(item).price;
                    this.setState({price_range: this.state.price_range, min: JSON.parse(item).price});
                } catch (e) {
                }
            });
        },
        setMaxPrice: (item) => {
            this.setState({max_price: item}, () => {
                try {
                    this.state.price_range[1] = JSON.parse(item).price;
                    this.setState({price_range: this.state.price_range, max: JSON.parse(item).price});
                } catch (e) {
                }
            });
        },
        clear: () => {
            this.setState({
                search: '',
                beds: {first: null, second: null},
                sort_value: this.state.sort_value_revert,
                first_drag: true,
            }, () => {
                this.parsers.listings(this.state.listings_data);
            });
        },
        setSort: (item) => {
            this.setState({sort_value: item})
        },
        link: (id) => {
            if (dataRegister.getDomain()) {
                if(dataRegister.getDomain() === "devyieldspotter.com"){
                    window.open("https://lp." + "devyieldlock.com" + "/" + id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
                }else if(dataRegister.getDomain() === "yieldspotter.com"){
                    window.open("https://lp." + "yieldlock.com" + "/" + id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
                }else{
                    window.open("https://lp." + dataRegister.getDomain() + "/" + id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
                }
            } else {
                window.open("https://lp." + "devyieldlock.com" + "/" + id + "?currency=" + this.state.currency + (this.state.from_channel ? "&utm_medium=" + this.state.from_channel : "") + (this.state.check_freetext ? "&remove_media_lock=true" : "") + (this.state.click_id[0] && this.state.click_id[1]? "&" + this.state.click_id[0] + "=" + this.state.click_id[1] : "") + (this.state.feed_id? "&utm_feed" + this.state.feed_id : ""), '_blank');
            }
        }
    };

    parsers = {
        init: (listings) => {
            let parsed = [];
            for (let i = 0; i < listings.length; i++) {
                try {
                    if (listings[i].data.landing_extra && !listings[i].data.expired) {
                        parsed.push(this.parsers.listing(listings[i].data));
                    }
                } catch (e) {
                }
            }
            return parsed;
        },
        featured: (listings) => {
            for (let i = 0; i < listings.length; i++) {
                try {
                    if (listings[i].video) {
                        this.state.featured.push(listings[i]);
                    }
                } catch (e) {
                }
            }

            this.setState({featured: this.state.featured, isLoadingFeatured: false}, () => {
                //console.log(this.state.featured);
            });
        },
        categories: (listings) => {
            for (let i = 0; i < listings.length; i++) {
                try {
                    if (listings[i].identifier === 'sale') {
                        this.state.categories['sales'].items.push(listings[i]);
                    }
                    if (listings[i].identifier === 'rent') {
                        this.state.categories['rentals'].items.push(listings[i]);
                    }
                    if (listings[i].completion_status.toLowerCase() === this.state.category_value_ready) {
                        this.state.categories['ready'].items.push(listings[i]);
                    }
                    if (listings[i].completion_status.toLowerCase() === this.state.category_value_offplan) {
                        this.state.categories['offplan'].items.push(listings[i]);
                    }
                    if (listings[i].completion_status.toLowerCase() === this.state.category_value_new) {
                        this.state.categories['new'].items.push(listings[i]);
                    }
                    /*
                    if (listings[i].completion_status.toLowerCase() === 'property investment') {
                        this.state.categories['investment'].items.push(listings[i]);
                    }
                    /*/
                } catch (e) {
                }
            }
            this.state.categories['sales'].loading = false;
            this.state.categories['rentals'].loading = false;
            this.state.categories['ready'].loading = false;
            this.state.categories['offplan'].loading = false;
            this.state.categories['new'].loading = false;
            //this.state.categories['investment'].loading = false;
            this.setState({categories: this.state.categories});
        },
        categories_yl: (listings) => {
            for (let i = 0; i < listings.length; i++) {
                try {
                    if (listings[i].identifier === 'sale') {
                        this.state.categories_yl['all'].items.push(listings[i]);
                    }
                    if (listings[i].years === 3) {
                        this.state.categories_yl['3y'].items.push(listings[i]);
                    }
                    if (listings[i].years === 4) {
                        this.state.categories_yl['4y'].items.push(listings[i]);
                    }
                    if (listings[i].years === 5) {
                        this.state.categories_yl['5y'].items.push(listings[i]);
                    }
                    if (listings[i].years === 6) {
                        this.state.categories_yl['6y'].items.push(listings[i]);
                    }
                    if (listings[i].years === 7) {
                        this.state.categories_yl['7y'].items.push(listings[i]);
                    }
                    /*
                    if (listings[i].completion_status.toLowerCase() === 'property investment') {
                        this.state.categories['investment'].items.push(listings[i]);
                    }
                    /*/
                } catch (e) {
                }
            }
            this.state.categories_yl['all'].loading = false;
            this.state.categories_yl['3y'].loading = false;
            this.state.categories_yl['4y'].loading = false;
            this.state.categories_yl['5y'].loading = false;
            this.state.categories_yl['6y'].loading = false;
            this.state.categories_yl['7y'].loading = false;
            //this.state.categories['investment'].loading = false;
            this.setState({categories: this.state.categories_yl});
        },
        types: (listings) => {
            let types = {
                [this.state.types[0].title]: [],
                [this.state.types[1].title]: [],
                [this.state.types[2].title]: [],
                [this.state.types[3].title]: [],
                [this.state.types[4].title]: []
                //'investments': []
            };
            for (let i = 0; i < listings.length; i++) {
                try {
                    if (listings[i].identifier === 'sale') {
                        types[this.state.types[0].title].push(listings[i]);
                    }
                    if (listings[i].identifier === 'rent') {
                        types[this.state.types[1].title].push(listings[i]);
                    }
                } catch (e) {
                    console.log(e);
                }
                try {
                    if (listings[i].completion_status.toLowerCase() === this.state.category_value_ready) {
                        types[this.state.types[2].title].push(listings[i]);
                    }
                    if (listings[i].completion_status.toLowerCase() === this.state.category_value_offplan) {
                        types[this.state.types[3].title].push(listings[i]);
                    }
                    if (listings[i].completion_status.toLowerCase() === this.state.category_value_new) {
                        types[this.state.types[4].title].push(listings[i]);
                    }
                    /*
                    if (listings[i].completion_status.toLowerCase() === 'property investment') {
                        types['investments'].push(listings[i]);
                    }
                    /*/
                } catch (e) {
                    console.log(e);
                }
            }
            this.setState({types_listings: types});
        },
        types_yl: (listings) => {
            let types = {
                'all': [],
                '3y deals': [],
                '4y deals': [],
                '5y deals': [],
                '6y deals': [],
                '7y deals': []
                //'investments': []
            };
            for (let i = 0; i < listings.length; i++) {
                try {
                    if (listings[i].identifier === 'sales') {
                        types.all.push(listings[i]);
                    }
                } catch (e) {
                    console.log(e);
                }
                try {
                    if (listings[i].years === 3) {
                        types['3y deals'].push(listings[i]);
                    }
                    if (listings[i].years === 4) {
                        types['4y deals'].push(listings[i]);
                    }
                    if (listings[i].years === 5) {
                        types['5y deals'].push(listings[i]);
                    }
                    if (listings[i].years === 6) {
                        types['6y deals'].push(listings[i]);
                    }
                    if (listings[i].years === 7) {
                        types['7y deals'].push(listings[i]);
                    }
                } catch (e) {
                    console.log(e);
                }
            }
            this.setState({types_listings: types});
        },
        listings: (listings) => {

            let parsed = [];
            let default_range = [];
            let min = null;
            let max = null;

            //FILTER IDENTIFIER
            let identifier = [];

            if ((this.renderYieldlock() || this.renderYieldspotter())) {

                identifier = this.state.types_yl.filter((item) => {
                    return item.selected
                });

                try {
                    if (identifier[0].title === 'all') {
                        listings = listings.filter((item) => {
                            return (item.identifier === 'all');
                        });
                    } else if (identifier[0].title === '3y deals') {
                        listings = listings.filter((item) => {
                            if (item.years) {
                                return (item.years === 3);
                            } else {
                                return false
                            }
                        });
                    } else if (identifier[0].title === '4y deals') {
                        listings = listings.filter((item) => {
                            if (item.years) {
                                return (item.years === 4);
                            } else {
                                return false
                            }
                        });
                    } else if (identifier[0].title === '5y deals') {
                        listings = listings.filter((item) => {
                            if (item.years) {
                                return (item.years === 5);
                            } else {
                                return false
                            }
                        });
                    } else if (identifier[0].title === '6y deals') {
                        listings = listings.filter((item) => {
                            if (item.years) {
                                return (item.years === 6);
                            } else {
                                return false
                            }
                        });
                    } else if (identifier[0].title === '7y deals') {
                        listings = listings.filter((item) => {
                            if (item.years) {
                                return (item.years === 7);
                            } else {
                                return false
                            }
                        });
                    }
                } catch (e) {
                    console.log(e);
                }

            } else {

                identifier = this.state.types.filter((item) => {
                    return item.selected
                });

                try {
                    if (identifier[0].title === this.state.types[0].title) {
                        listings = listings.filter((item) => {
                            return (item.identifier === 'sale');
                        });
                    } else if (identifier[0].title === this.state.types[1].title) {
                        listings = listings.filter((item) => {
                            return (item.identifier === 'rent');
                        });
                    } else if (identifier[0].title === this.state.types[2].title) {
                        listings = listings.filter((item) => {
                            if (item.completion_status) {
                                return (item.completion_status.toLowerCase() === this.state.category_value_ready);
                            } else {
                                return false
                            }
                        });
                    } else if (identifier[0].title === this.state.types[3].title) {
                        listings = listings.filter((item) => {
                            if (item.completion_status) {
                                return (item.completion_status.toLowerCase() === this.state.category_value_offplan);
                            } else {
                                return false
                            }
                        });
                    } else if (identifier[0].title === this.state.types[4].title) {
                        listings = listings.filter((item) => {
                            if (item.completion_status) {
                                return (item.completion_status.toLowerCase() === this.state.category_value_new);
                            } else {
                                return false
                            }
                        });
                    } /* else if (identifier[0].title === 'investments') {
                    listings = listings.filter((item) => {
                        if (item.completion_status) {
                            return (item.completion_status.toLowerCase() === 'property investment');
                        } else {
                            return false
                        }
                    });
                }
                /*/
                } catch (e) {
                    console.log(e);
                }

            }

            //console.log(listings);

            //FILTER BEDS
            try {
                let first = null;
                let second = null;
                if (this.state.beds.first && !this.state.beds.second) {
                    first = this.state.beds.first;
                } else if (this.state.beds.first && this.state.beds.second) {
                    if (this.state.beds.first < this.state.beds.second) {
                        first = this.state.beds.first;
                        second = this.state.beds.second;
                    } else {
                        first = this.state.beds.second;
                        second = this.state.beds.first;
                    }
                }
                listings = listings.filter((item) => {
                    if (first && !second) {
                        if (first > 4) {
                            return item.beds > 3
                        } if (first === 1) {
                            return item.beds <= (first - 1)
                        } else {
                            return item.beds === (first - 1)
                        }
                    } else if (first && second) {
                        if (second > 3) {
                            return item.beds >= (first - 1);
                        } else {
                            return item.beds >= (first - 1) && item.beds <= (second - 1)
                        }
                    } else {
                        return true;
                    }
                });
            } catch (e) {
            }

            //console.log(listings);

            for (let i = 0; i < listings.length; i++) {
                try {
                    try {
                        if (min !== null) {
                            if (min > listings[i].price) {
                                min = listings[i].price
                            }
                        } else {
                            min = listings[i].price
                        }
                        if (max !== null) {
                            if (max < listings[i].price) {
                                max = listings[i].price
                            }
                        } else {
                            max = listings[i].price
                        }
                    } catch (e) {
                    }
                } catch (e) {
                }
            }

            //console.log(listings);


            let min_value = 121;
            let min_values = [
                {price: 0, disabled: false},
                {price: 100, disabled: false},
                {price: 200, disabled: false},
                {price: 300, disabled: false},
                {price: 400, disabled: false},
                {price: 500, disabled: false}
            ];
            let max_value = 301;
            let max_values = [
                {price: 0, disabled: false},
                {price: 100, disabled: false},
                {price: 200, disabled: false},
                {price: 300, disabled: false},
                {price: 400, disabled: false},
                {price: 500, disabled: false}
            ];

            let first_disabled = false;
            for (let i = 0; i < min_values.length; i++) {
                if (min_values[i].price < min_value) {
                    min_values[i].disabled = true;
                    max_values[i].disabled = true;
                }
                if (!min_values[i].disabled && !first_disabled) {
                    try {
                        min_values[i - 1].disabled = false;
                    } catch (e) {
                        min_values[0].disabled = false;
                    }
                    first_disabled = true;
                }
            }

            /*
            console.log(min_values);
            console.log(max_values);


            first_disabled = true;
            let first_min = 0;
            for(let i = 0; i < this.state.min_prices.length; i++){
                if(this.state.min_prices[i].price < min){
                    this.state.min_prices[i].disabled = true;
                    this.state.max_prices[i].disabled = true;
                }
                if(first_disabled && i > 0 && !this.state.min_prices[i].disabled){
                    this.state.min_prices[i - 1].disabled = false;
                    this.state.max_prices[i - 1].disabled = false;
                    first_min = this.state.min_prices[i - 1].price;
                    this.state.min_price = JSON.stringify(this.state.min_prices[i - 1]);
                    first_disabled = false;
                }
            }

            if(!this.state.min_prices[0].disabled){
                first_min = this.state.min_prices[0].price;
            }

            first_disabled = true;
            let first_max = 0;
            for(let i = this.state.max_prices.length - 1; i > 0; i--){
                if(this.state.max_prices[i].price > max){
                    this.state.min_prices[i].disabled = true;
                    this.state.max_prices[i].disabled = true;
                }
                if(first_disabled && i < this.state.max_prices.length - 1 && !this.state.max_prices[i].disabled){
                    this.state.max_prices[i + 1].disabled = false;
                    first_max = this.state.max_prices[i + 1].price;
                    this.state.max_price = JSON.stringify(this.state.min_prices[i + 1]);
                    first_disabled = false;
                }
            }
            */

            default_range.push(min);
            default_range.push(max);

            if (this.state.beds_selected) {
                //Add function with search tracking script here
                //note: if search query top result is reseller listing, need to initiate reseller tracker and trigger search event on tracker corresponding to that reseller
                //note: only trigger search event on listings with feed_data
                //note: add listing ID for multiple top results to dimension?
                //console.log("beds selected");
            }

            this.setState({
                //min_prices: this.state.min_prices,
                //max_prices: this.state.max_prices,
                //min_price: this.state.min_price,
                //max_price: this.state.max_price,
                listings: listings,
                isLoading: false,
                min: min,
                max: max,
                default: default_range,
                price_range: default_range,
                beds_selected: false
            }, () => {
                console.log(listings);
                console.log(default_range);
                console.log(min);
                console.log(max);
            })

        },
        listing: (listing) => {
            let object = {
                id: null,
                website_advertiser: null,
                website_address: null,
                address: '',
                slogans: [],
                industry: null,
                impressions: 0,
                created_at: '',
                date: null,
                lat: null,
                lng: null,
                image: null,
                video: null,
                identifier: null,
                duration: null,
                beds: null,
                completion_status: null,
                furnishings: null,
                amenities: [],
                price: 0,
                currency: null,
                location: null,
                type: null,
                market_price: null,
                list_price: null,
                yield: null,
                feed_data: false,
                just_listed: false,
                price_change: false,
                old_price: null
            };
            try {
                if (listing['landingpage-id']) {
                    object.id = listing['landingpage-id'];
                }
            } catch (e) {
            }
            try {
                if (listing.website_advertiser) {
                    object.website_advertiser = listing.website_advertiser;
                }
            } catch (e) {
            }
            try {
                if (listing.website_address) {
                    object.address = listing.website_address;
                }
            } catch (e) {
            }
            try {
                if (listing.slogans) {
                    object.slogans = listing.slogans;
                }
            } catch (e) {
            }
            try {
                if (listing.industry) {
                    object.industry = listing.industry;
                }
            } catch (e) {
            }
            try {
                if (listing.impressions) {
                    object.impressions = listing.impressions;
                }
            } catch (e) {
            }
            try {
                if (listing.created_at) {
                    object.date = moment(listing.created_at).format('YYYYMMDD');
                }
            } catch (e) {
            }
            try {
                if (listing.lat && listing.lng) {
                    object.lat = listing.lat;
                    object.lng = listing.lng;
                }
            } catch (e) {
            }
            try {
                if (listing.image) {
                    object.image = listing.image;
                }
            } catch (e) {
            }
            try {
                if (listing.video) {
                    object.video = listing.video;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.image0) {
                    object.image0 = listing.landing_extra.image0;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.identifier) {
                    object.identifier = listing.landing_extra.identifier;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.duration) {
                    object.duration = listing.landing_extra.duration;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.beds) {
                    object.beds = listing.landing_extra.beds;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.completion_status) {
                    object.completion_status = listing.landing_extra.completion_status;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.furnishings) {
                    object.furnishings = listing.landing_extra.furnishings;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.amenities) {
                    object.amenities = listing.landing_extra.amenities;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.price) {
                    object.price = listing.landing_extra.price;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.currency) {
                    object.currency = listing.landing_extra.currency;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.location) {
                    object.location = listing.landing_extra.location;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.yieldlock.list_price) {
                    object.list_price = listing.landing_extra.yieldlock.list_price;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.yieldlock.market_price) {
                    object.market_price = listing.landing_extra.yieldlock.market_price;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.yieldlock.years) {
                    object.years = listing.landing_extra.yieldlock.years;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.yieldlock.yield) {
                    object.yield = listing.landing_extra.yieldlock.yield;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.engagement) {
                    object.engagement = listing.landing_extra.engagement;
                }
            } catch (e) {
            }
            try {
                if (listing.reactions) {
                    object.reactions = listing.reactions;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.feed_data) {
                    object.feed_data = listing.landing_extra.feed_data;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.just_listed) {
                    object.just_listed = listing.landing_extra.just_listed;
                }
            } catch (e) {
            }
            try {
                if (listing.landing_extra.price_change) {
                    object.price_change = listing.landing_extra.price_change;
                }
                //object.price_change = true;
            } catch (e) {
            }
            try {
                if (listing.landing_extra.old_price) {
                    object.old_price = listing.landing_extra.old_price;
                }
                //object.old_price = 1395000;
            } catch (e) {
            }
            return object;
        }
    };

    scraper = {};

    validators = {
        website: (value) => {
            var re = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
            return re.test(String(value).toLowerCase());
        }
    };

    filters = {
        tags_areas: (limit) => {
            if (this.state.listings && this.state.listings.length > 3) {

                let amount = limit ? limit : 10;
                let listings = this.state.listings;
                let components = [];
                let location_tags = [];
                let merged_location_tags = [];
                let sorted_location_tags = [];

                for (let i = 0; i < listings.length; i++) {
                    if (listings[i].address) {
                        components = listings[i].address.split(/[\-]/g);
                        components = components[0].split(/[\,]/);
                        location_tags[i] = components[0].trim().toLowerCase();
                    }
                }

                //REMOVE DUPLICATES
                 merged_location_tags = location_tags.filter((c, index) => {return location_tags.indexOf(c) === index});

                //SORT ALPHABETICALLY
                sorted_location_tags = merged_location_tags.sort(function(a, b){
                    if(a < b) { return -1; }
                    if(a > b) { return 1; }
                    return 0;
                });

                return sorted_location_tags.filter((item, index) => {return index < amount});
            } else {
                return false;
            }
        },
        tags_types: (limit) => {
            if (this.state.listings && this.state.listings.length > 3) {

                let amount = limit ? limit : 8;
                let listings = this.state.listings;
                let industry_tags = [];
                let merged_industry_tags = [];
                let sorted_industry_tags = [];

                for (let i = 0; i < listings.length; i++) {
                    if (listings[i].industry[this.state.lang]) {
                        industry_tags[i] = listings[i].industry[this.state.lang].toLowerCase();
                    }
                }

                //REMOVE DUPLICATES
                merged_industry_tags = industry_tags.filter((c, index) => {return industry_tags.indexOf(c) === index});

                //SORT ALPHABETICALLY
                sorted_industry_tags = merged_industry_tags.sort(function(a, b){
                    if(a < b) { return -1; }
                    if(a > b) { return 1; }
                    return 0;
                });

                return sorted_industry_tags.filter((item, index) => {return index < amount});
            } else {
                return false;
            }
        },
        tags_merged: (limit_areas,limit_types) => {
            let merged = [];
            merged = merged.concat(this.filters.tags_types(limit_types), this.filters.tags_areas(limit_areas));
            if (merged && merged.length > 3) {
                return merged
            } else {
                return false
            }
        },
        listings: () => {
            let listings = this.state.listings;
            let listings2 = this.state.listings;
            let components = [];
            let total = 0;

            if (this.state.search !== "" && this.state.search.indexOf(",") !== -1) {
                components = this.state.search.split(/[\,]/);
                total = components.length;
            }

            if (total > 0) {
                //FILTER SEARCH
                listings = listings.filter((item) => {
                    try {
                        if (this.state.search !== "") {
                            return (
                                item.location.toLowerCase().indexOf(components[0].trim().toLowerCase()) !== -1 ||
                                item.address.toLowerCase().indexOf(components[0].trim().toLowerCase()) !== -1
                            )
                        } else {
                            return true;
                        }
                    } catch (e) {
                    }
                });
                listings2 = listings;
                //LEVEL 1 exist
                listings2 = listings2.filter((item) => {
                    try {
                        if (this.state.search !== "" && item.address.toLowerCase().indexOf(components[1].trim().toLowerCase()) !== -1) {
                            return (
                                item.address.toLowerCase().indexOf(components[1].trim().toLowerCase()) !== -1 ||
                                item.industry[this.state.lang].toLowerCase().indexOf(components[1].trim().toLowerCase()) !== -1
                            )
                        } else {
                            return true;
                        }
                    } catch (e) {
                    }
                });
                listings2 = listings2.filter((item) => {
                    try {
                        if (this.state.search !== "" && item.address.toLowerCase().indexOf(components[1].trim().toLowerCase()) === -1) {
                            return (
                                item.industry[this.state.lang].toLowerCase().indexOf(components[1].trim().toLowerCase()) !== -1 ||
                                item.amenities.join().toLowerCase().indexOf(components[1].trim().toLowerCase()) !== -1
                            )
                        } else {
                            return true;
                        }
                    } catch (e) {
                    }
                });
                //LEVEL 2 exist
                listings = listings.filter((item) => {
                    try {
                        if (this.state.search !== "") {
                            return (
                                item.address.toLowerCase().indexOf(components[1].trim().toLowerCase()) !== -1 ||
                                item.industry[this.state.lang].toLowerCase().indexOf(components[1].trim().toLowerCase()) !== -1
                            )
                        } else {
                            return true;
                        }
                    } catch (e) {
                    }
                });
                listings = listings.filter((item) => {
                    try {
                        if (this.state.search !== "" && item.address.toLowerCase().indexOf(components[1].trim().toLowerCase()) !== -1) {
                            return (
                                item.industry[this.state.lang].toLowerCase().indexOf(components[2].trim().toLowerCase()) !== -1 ||
                                item.amenities.join().toLowerCase().indexOf(components[2].trim().toLowerCase()) !== -1
                            )
                        } else {
                            return true;
                        }
                    } catch (e) {
                    }
                });
                listings = listings.filter((item) => {
                    try {
                        if (this.state.search !== "" && item.industry[this.state.lang].toLowerCase().indexOf(components[1].trim().toLowerCase()) !== -1) {
                            return (
                                item.amenities.join().toLowerCase().indexOf(components[2].trim().toLowerCase()) !== -1
                            )
                        } else {
                            return true;
                        }
                    } catch (e) {
                    }
                });

                if (!(components[1] && components[2])) {
                    listings = listings2;
                }

            } else {
                //FILTER SEARCH
                listings = listings.filter((item) => {
                    try {
                        if (this.state.search !== "") {
                            return (
                                item.industry[this.state.lang].toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 ||
                                item.location.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 ||
                                item.address.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 ||
                                item.amenities.join().toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                            )
                        } else {
                            return true;
                        }
                    } catch (e) {
                    }
                });
            }

            //FILTER PRICE
            listings = listings.filter((item, index) => {
                return (item.price >= this.state.price_range[0] && item.price <= this.state.price_range[1]);
            });

            return listings;
        },
        limit: (listings) => {

            listings = listings.filter((item, index) => {
                return index < (this.state.page_size * this.state.page);
            });

            return listings;
        }
    };

    sort = {
        listings: (listings) => {
            try {
                //FILTER IDENTIFIER
                let sort = JSON.parse(this.state.sort_value);
                console.log(sort.value);
                console.log(sort.option);
                if (sort) {
                    if (sort.option) {
                        return listings.sort((a, b) => (a[sort.value] > b[sort.value]) ? 1 : -1)
                    } else {
                        return listings.sort((a, b) => (a[sort.value] < b[sort.value]) ? 1 : -1)
                    }
                } else {
                    return listings;
                }
            } catch (e) {
                return listings;
            }
        }
    };

    renders = {
        price: (price) => {
            try {
                if (Math.round(this.state.rates_data[this.state.currency] * price)) {
                    return Math.round(this.state.rates_data[this.state.currency] * price);
                }
            } catch (e) {
                console.log(e);
            }
        },
        text: (item) => {
            return langRegister.get("booster-listing", item, this.state.lang);
        },
        saleschannel: () => {
            try {
                if (window.location.hostname.indexOf("propertybooster") !== -1) {
                    return 'propertybooster'
                } else if (window.location.hostname.indexOf("boostabostad") !== -1) {
                    return 'boostabostad'
                } else if (window.location.hostname.indexOf("yieldlock") !== -1) {
                    return 'yieldlock'
                } else if (window.location.hostname.indexOf("yieldspotter") !== -1) {
                    //return 'yieldspotter'
                    //Must fetch saleschannel yieldlock for Yieldspotter or landing pages will not be loaded
                    return 'yieldlock'
                } else {
                    return 'propertybooster'
                }
            } catch (e) {
                return 'propertybooster'
            }
        },
        numbers: (x) => {
            try {
                if (x >= 0) {
                    x = Math.round(x * 100) / 100;
                    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                } else {
                    return 0
                }
            } catch (e) {
                return ("...")
            }
        },
        address: (address, location) => {
            try {
                let components = address.split(/[\-]/g);
                components = components[0].split(/[\,]/);
                if (components[0] && components[0].trim() !== location.trim()) {
                    components[0] = components[0];
                    if (this.state.format_small) {
                        if (components[0].length > 30) {
                            let string = ', ' + components[0].substring(0, 30) + '...';
                            return string;
                        } else {
                            return ', ' + components[0];
                        }
                    } else {
                        if (components[0].length > 15) {
                            let string = ', ' + components[0].substring(0, 15) + '...';
                            return string;
                        } else {
                            return ', ' + components[0];
                        }
                    }
                }
            } catch (e) {
                console.log(e);
            }

        },
        address_mobile: (address, location) => {
            try {
                let components = address.split(/[\-]/g);
                components = components[0].split(/[\,]/);
                if (components[0] && components[0].trim() !== location.trim()) {
                    components[0] = components[0];
                    if (this.state.format_small) {
                        if (components[0].length > 30 && window.innerWidth > 400 && window.innerWidth < 450) {
                            let string = ', ' + components[0].substring(0, 30) + '...';
                            return string;
                        } else if (components[0].length > 30 && window.innerWidth <= 400) {
                            let string = ', ' + components[0].substring(0, 30) + '...';
                            return string;
                        } else if (components[0].length > 55 && window.innerWidth >= 450 && window.innerWidth < 900) {
                            let string = ', ' + components[0].substring(0, 55) + '...';
                            return string;
                        } else if (components[0].length > 40 && window.innerWidth >= 900) {
                            let string = ', ' + components[0].substring(0, 40) + '...';
                            return string;
                        } else {
                            return ', ' + components[0];
                        }
                    } else {
                        if (components[0].length > 12 && window.innerWidth > 400 && window.innerWidth < 450) {
                            let string = ', ' + components[0].substring(0, 12) + '...';
                            return string;
                        } else if (components[0].length > 7 && window.innerWidth <= 400) {
                            let string = ', ' + components[0].substring(0, 7) + '...';
                            return string;
                        } else if (components[0].length > 35 && window.innerWidth >= 450 && window.innerWidth < 900) {
                            let string = ', ' + components[0].substring(0, 35) + '...';
                            return string;
                        } else if (components[0].length > 15 && window.innerWidth >= 900) {
                            let string = ', ' + components[0].substring(0, 15) + '...';
                            return string;
                        } else {
                            return ', ' + components[0];
                        }
                    }
                }
            } catch (e) {
                console.log(e);
            }

        },
        industry_mobile: (industry) => {
            if (industry) {
                let input = industry;
                if (this.state.format_small) {
                    if (input.length > 24) {
                        return input.substring(0, 25) + '...';
                    } else {
                        return input
                    }
                } else {
                    if (input.length > 14) {
                        return input.substring(0, 15) + '...';
                    } else {
                        return input
                    }
                }
            } else {
                return industry
            }
        },
        beds: (beds) => {
            try {
                //FILTER IDENTIFIER
                let identifier = this.state.types.filter((item) => {
                    return item.selected
                });
                return this.state.types_listings[identifier[0].title.toLowerCase()].filter((item) => {
                    return item.beds === beds
                }).length < 1
            } catch (e) {
                return false
            }
        },
        sort: () => {
            try {
                return JSON.parse(this.state.sort_value).title;
            } catch (e) {
            }
        },
        type: () => {
            try {
                return JSON.parse(this.state.type_value).title;
            } catch (e) {
            }
        },
        branding: () => {
            try{
                let query = queryString.parse(this.props.location.search);
                if(query.id && !(this.renderYieldlock() || this.renderYieldspotter() || this.renders.platformTeaser())){
                    return true;
                } else {
                    return false;
                }
            }catch (e) {}
        },
        brandingPrimaryColor: () => {
            if (this.state.reseller_primary) {
                return this.state.reseller_primary;
            } else {
                try{
                    let query = queryString.parse(this.props.location.search);
                    if(query.primary){
                        return '#' + query.primary;
                    } else {
                        return '#BFBFBF';
                    }
                }catch (e) {}
            }
        },
        platformTeaser: () => {
            try {
                if (window.location.hostname.indexOf('dev') !== -1 && !this.renderYieldspotter()) {
                    return false
                } else if (window.location.hostname.indexOf('dev') !== -1 && this.renderYieldspotter()) {
                    return false
                } else if (window.location.hostname.indexOf('localhost') !== -1) {
                    return false
                } else if (this.renders.overrideTeaser()) {
                    return false
                } else {
                    return true
                }
            } catch (e) {
                return true
            }
        },
        overrideTeaser: () => {
            try{
                let query = queryString.parse(this.props.location.search);
                if(query.search === "true"){
                    this.state.override_teaser = true;
                    return true;
                } else {
                    this.state.override_teaser = false;
                    return false;
                }
            }catch (e) {}
        },
        newsFeed: () => {
            try{
                if (this.renderPropertyBooster() || this.renderBoostaBostad()) {
                    return true
                } else {
                    return false
                }
            }catch (e) {}
        },
        amenities: (item) => {
            try {
                let selected = [];
                for (let i = 0; i < item.amenities.length; i++) {
                    if (item.amenities[i].toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1 && i < 10) {
                        selected.push(item.amenities[i]);
                    }
                }
                return selected;
            } catch (e) {
                return [];

            }
        },
        getFacebookFeedEventData: (listing) => {
            let event_data = {};
            event_data.content_ids = [listing.id]; // REQUIRED: IDs top search results
            event_data.content_type = ['home_listing']; // REQUIRED: DO NOT change this, must be set to 'home_listing'
            // Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.city) {
                        event_data.city = listing.feed_data.city;
                    }
                }
            } catch (e) {
            }
            // Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.region) {
                        event_data.region = listing.feed_data.region;
                    }
                }
            } catch (e) {
            }
            // Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.country) {
                        event_data.country = listing.feed_data.country;
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.neighborhood) {
                        event_data.neighborhood = listing.feed_data.neighborhood;
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.currency) {
                        event_data.currency = listing.feed_data.currency.toUpperCase();
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.identifier) {
                        let sold = listing.feed_data.sold ? listing.feed_data.sold : false;
                        if (listing.feed_data.identifier === 'sale' && !sold) {
                            event_data.availability = 'for_' + listing.feed_data.identifier.toLowerCase();
                        } else if (sold) {
                            event_data.availability = 'recently_sold';
                        } else {
                            event_data.availability = 'for_' + listing.feed_data.identifier.toLowerCase();
                        }
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.identifier) {
                        event_data.listing_type = 'for_' + listing.feed_data.identifier.toLowerCase() + '_by_agent';
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.industry) {

                        if (listing.industry['en'].toLowerCase().indexOf('studio') !== -1 || listing.industry['en'].toLowerCase().indexOf('bed for') !== -1 || listing.industry['en'].toLowerCase().indexOf('penthouse') !== -1 || listing.industry['en'].toLowerCase().indexOf('duplex') !== -1) {
                            event_data.property_type = 'apartment';
                        } else if (listing.industry['en'].toLowerCase().indexOf('villa') !== -1 || listing.industry['en'].toLowerCase().indexOf('bungalow') !== -1) {
                            event_data.property_type = 'house';
                        } else if (listing.industry['en'].toLowerCase().indexOf('townhouse') !== -1) {
                            event_data.property_type = 'townhouse';
                        } else {
                            event_data.property_type = 'other';
                        }

                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.baths) {
                        event_data.preferred_baths_range = [listing.feed_data.baths, listing.feed_data.baths];
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.beds) {
                        event_data.preferred_beds_range = [listing.feed_data.beds, listing.feed_data.beds];
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.price) {
                        event_data.preferred_price_range = [listing.feed_data.price, listing.feed_data.price];
                    }
                }
            } catch (e) {
            }
            return event_data;
        },
        getGoogleFeedEventData: (listing) => {
            let event_data = {};
            event_data.listing_id = listing.id; // REQUIRED: Listing ID
            // event_data.listing_pagetype = ''; SET THIS ON EACH EVENT: Standard values used for automatic list creation are: home, searchresults, offerdetail, conversionintent, and conversion
            // NOT Required (custom dimension exist)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.city) {
                        event_data.city_name = listing.feed_data.city;
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.region) {
                        event_data.region = listing.feed_data.region;
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.country) {
                        event_data.country = listing.feed_data.country;
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.neighborhood) {
                        event_data.neighborhood = listing.feed_data.neighborhood;
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.currency) {
                        event_data.currency = listing.feed_data.currency.toUpperCase();
                    }
                }
            } catch (e) {
            }
            // NOT Required (custom dimension exist)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.industry) {
                        event_data.listing_name = listing.feed_data.industry;
                    }
                }
            } catch (e) {
            }
            // NOT Required (custom dimension exist)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.identifier) {
                        event_data.listing_type = 'For ' + listing.feed_data.identifier.toLowerCase();
                    }
                }
            } catch (e) {
            }
            // NOT Required (custom dimension exist)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.industry) {

                        if (listing.industry['en'].toLowerCase().indexOf('studio') !== -1 || listing.industry['en'].toLowerCase().indexOf('bed for') !== -1 || listing.industry['en'].toLowerCase().indexOf('penthouse') !== -1 || listing.industry['en'].toLowerCase().indexOf('duplex') !== -1) {
                            event_data.property_type = 'Apartment';
                        } else if (listing.industry['en'].toLowerCase().indexOf('villa') !== -1 || listing.industry['en'].toLowerCase().indexOf('bungalow') !== -1) {
                            event_data.property_type = 'House';
                        } else if (listing.industry['en'].toLowerCase().indexOf('townhouse') !== -1) {
                            event_data.property_type = 'Townhouse';
                        } else {
                            event_data.property_type = 'Apartment';
                        }

                    }
                }
            } catch (e) {
            }
            // NOT Required (custom dimension exist)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.baths) {
                        event_data.baths = listing.feed_data.baths;
                    }
                }
            } catch (e) {
            }
            // NOT Required (custom dimension exist)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.beds) {
                        event_data.beds = listing.feed_data.beds;
                    }
                }
            } catch (e) {
            }
            // NOT Required (custom dimension exist)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.price && listing.feed_data.currency) {
                        event_data.price = listing.feed_data.price + ' ' + listing.feed_data.currency.toUpperCase();
                    }
                }
            } catch (e) {
            }
            // NOT Required (custom dimension exist)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.price) {
                        event_data.listing_totalvalue = listing.feed_data.price;
                    }
                }
            } catch (e) {
            }
            return event_data;
        },
        getTiktokFeedEventData: (listing) => {
            let event_data = {};
            event_data.content_id = listing.id; // REQUIRED: Content ID
            event_data.content_type = 'product'; //REQUIRED: The content_type object property's value must be set to either product, or product_group, depending on how you will configure your data feed when you set up your product catalog. If you will be tracking events associated with individual products, set the value to product.
            event_data.quantity = 1; //NOT Required:
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.industry) {
                        event_data.content_name = listing.feed_data.industry;
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.industry) {

                        if (this.state.industry['en'].toLowerCase().indexOf('studio') !== -1 || this.state.industry['en'].toLowerCase().indexOf('bed for') !== -1 || this.state.industry['en'].toLowerCase().indexOf('penthouse') !== -1 || this.state.industry['en'].toLowerCase().indexOf('duplex') !== -1) {
                            event_data.content_category = 'Apartment';
                        } else if (this.state.industry['en'].toLowerCase().indexOf('villa') !== -1 || this.state.industry['en'].toLowerCase().indexOf('bungalow') !== -1) {
                            event_data.content_category = 'House';
                        } else if (this.state.industry['en'].toLowerCase().indexOf('townhouse') !== -1) {
                            event_data.content_category = 'Townhouse';
                        } else {
                            event_data.content_category = 'Apartment';
                        }

                    }
                }
            } catch (e) {
            }
            // NOT Required (recommended)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.currency) {
                        event_data.currency = listing.feed_data.currency.toUpperCase();
                    }
                }
            } catch (e) {
            }
            // NOT Required (recommended)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.price) {
                        event_data.price = listing.feed_data.price;
                    }
                }
            } catch (e) {
            }
            // NOT Required (recommended)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.price) {
                        event_data.value = listing.feed_data.price;
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.industry) {
                        event_data.query = listing.feed_data.industry.toLowerCase();
                    }
                }
            } catch (e) {
            }
            return event_data;
        },
        getSnapchatFeedEventData: (listing) => {
            let event_data = {};
            event_data.item_ids = [this.props.match.params.id]; // NOT Required: Items IDs (recommended)
            event_data.number_items = 1; //NOT Required:

            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.industry) {
                        event_data.description = listing.feed_data.industry;
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.industry) {

                        if (this.state.industry['en'].toLowerCase().indexOf('studio') !== -1 || this.state.industry['en'].toLowerCase().indexOf('bed for') !== -1 || this.state.industry['en'].toLowerCase().indexOf('penthouse') !== -1 || this.state.industry['en'].toLowerCase().indexOf('duplex') !== -1) {
                            event_data.item_category = 'Apartment';
                        } else if (this.state.industry['en'].toLowerCase().indexOf('villa') !== -1 || this.state.industry['en'].toLowerCase().indexOf('bungalow') !== -1) {
                            event_data.item_category = 'House';
                        } else if (this.state.industry['en'].toLowerCase().indexOf('townhouse') !== -1) {
                            event_data.item_category = 'Townhouse';
                        } else {
                            event_data.item_category = 'Apartment';
                        }

                    }
                }
            } catch (e) {
            }
            // NOT Required (recommended)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.currency) {
                        event_data.currency = listing.feed_data.currency.toUpperCase();
                    }
                }
            } catch (e) {
            }
            // NOT Required (recommended)
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.price) {
                        event_data.price = listing.feed_data.price;
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.industry) {
                        event_data.search_string = listing.feed_data.industry.toLowerCase();
                    }
                }
            } catch (e) {
            }
            // NOT Required
            try {
                if (listing.feed_data) {
                    if (listing.feed_data.industry) {
                        event_data.sign_up_method = this._getFromChannel();
                    }
                }
            } catch (e) {
            }
            return event_data;
        }
    };

    _checkFreetext() {
        let freetext = false;
        try {
            let query = queryString.parse(this.props.location.search);
            if (query.freetext && query.freetext !== "") {
                freetext = true;
            }
        } catch (e) {
        }
        return freetext;
    }

    _checkMedialock() {
        let medialock = false;
        try {
            let query = queryString.parse(this.props.location.search);
            if (query.medialock && query.medialock === "remove") {
                medialock = true;
            }
        } catch (e) {
        }
        return medialock;
    }

    _getFromChannel() {
        let from_channel = "";
        try {
            let query = queryString.parse(this.props.location.search);
            if (query && query.utm_medium) {
                from_channel = query.utm_medium;
            }
        } catch (e) {
        }
        return from_channel;
    }

    _getClickId() {
        let clickId = ["",""];
        try {
            let query = queryString.parse(this.props.location.search);
            if (query && query.gclid) {
                //GOOGLE standard
                clickId = ["gclid", query.gclid];
            } else if (query && query.wbraid) {
                //GOOGLE iOS
                clickId = ["wbraid", query.wbraid];
            } else if (query && query.fbclid) {
                //FACEBOOK
                clickId = ["fbclid", query.fbclid];
            } else if (query && query.msclkid) {
                //MICROSOFT
                clickId = ["msclkid", query.msclkid];
            } else if (query && query.ttclid) {
                //TIKTOK
                clickId = ["ttclid", query.ttclid];
            } else if (query && query.scclid) {
                //SNAPCHAT
                clickId = ["scclid", query.scclid];
            }
        } catch (e) {
            console.log(e);
        }
        return clickId;
    }

    _getFeedId() {
        let feedId = "";
        try {
            let query = queryString.parse(this.props.location.search);
            if (query && query.utm_feed) {
                feedId = query.utm_feed;
            }
        } catch (e) {
            console.log(e);
        }
        return feedId;
    }

    renderPropertyBooster() {
        try {
            return window.location.hostname.indexOf("propertybooster") !== -1
        } catch (e) {
            return false
        }
    }

    renderBoostaBostad() {
        try {
            return window.location.hostname.indexOf("boostabostad") !== -1
        } catch (e) {
            return false
        }
    }

    renderYieldlock() {
        try {
            return window.location.hostname.indexOf("yieldlock") !== -1
        } catch (e) {
            return false
        }
    }

    renderYieldspotter() {
        try {
            return window.location.hostname.indexOf("yieldspotter") !== -1
        } catch (e) {
            return false
        }
    }

    renderLoader() {
        let query = queryString.parse(this.props.location.search);
        try {
            if (query.id) {
                return '#BFBFBF'
                //return this.renders.brandingPrimaryColor();
            } else {
                if (window.location.hostname.indexOf("propertybooster") !== -1) {
                    return '#33B8CF'
                } else if (window.location.hostname.indexOf("boostabostad") !== -1) {
                    return '#7ECF5B'
                } else if (window.location.hostname.indexOf("yieldlock") !== -1) {
                    return '#00273A'
                } else if (window.location.hostname.indexOf("yieldspotter") !== -1) {
                    return '#00273A'
                } else {
                    return '#ffffff'
                }
            }
        } catch (e) {
            return '#ffffff'
        }
    }

    _renderReducedPrice(old_price, price) {
        try {
            if (old_price > 0) {
                return Math.round(((price - old_price) / old_price) * 100) < 0 ? this.renders.text("item_56") + Math.round(((price - old_price) / old_price) * 100) + "%" : this.renders.text("item_56") + "+" + Math.round(((price - old_price) / old_price) * 100) + "%";
            } else {
                return false
            }
        } catch (e) {
            return false
        }
    }

    _renderReducedPriceClean(old_price, price) {
        try {
            if (old_price > 0) {
                return Math.round(((price - old_price) / old_price) * 100);
            } else {
                return false
            }
        } catch (e) {
            return false
        }
    }

    _renderMarketPrice(value) {
        try {
            return value;
        } catch (e) {
            return false
        }
    }

    _renderListPrice(value) {
        try {
            return value;
        } catch (e) {
            return false
        }
    }

    _renderBadge(value1, value2) {
        return this._renderListPrice(value1) && this._renderMarketPrice(value2) && (this._renderMarketPrice(value2) > this._renderListPrice(value1)) && ((100 - ((this._renderListPrice(value1) / this._renderMarketPrice(value2)) * 100)) > 3);
    }

    _renderHandlePB(props) {
        const {value, impressions, titleTwo, dragging, index, budget, currency, title, min, max, ...restProps} = props;
        return (
            <Tooltip
                prefixCls="rc-slider-tooltip"
                overlay={value}
                visible={titleTwo ? dragging? true : false : true}
                placement="bottom"
                key={index}
                align={{
                    offset: [0, 25],
                }}
                arrowContent={
                    <div className={
                        cx(Styles.sliderContainerHandle, Styles.sliderContainerHandlePB,
                            {
                                [Styles.sliderContainerHandleLow]: min === max
                            })
                    }>
                        <div className={
                            cx(Styles.sliderContainerHandleTitle, Styles.sliderContainerHandleTitlePB,
                                {
                                    [Styles.sliderContainerHandleTitleLow]: min === max
                                })
                        }>
                            <div className={Styles.sliderContainerHandleTitleDesktop}>{title}</div>
                        </div>
                        <div className={Styles.sliderContainerHandleValue}>
                            {impressions}<span className={Styles.sliderContainerHandleValueCurrency}>{currency}</span>
                        </div>
                        <div className={
                            cx(Styles.sliderContainerHandleArrow, Styles.sliderContainerHandleArrowPB,
                                {
                                    [Styles.sliderContainerHandleArrowGrey]: min === max
                                })
                        }/>
                    </div>}
            >
                <Handle value={value} {...restProps} />
            </Tooltip>
        );
    }

    _renderHandleBB(props) {
        const {value, impressions, titleTwo, dragging, index, budget, currency, title, min, max, ...restProps} = props;
        return (
            <Tooltip
                prefixCls="rc-slider-tooltip"
                overlay={value}
                visible={titleTwo ? dragging? true : false : true}
                placement="bottom"
                key={index}
                align={{
                    offset: [0, 25],
                }}
                arrowContent={
                    <div className={
                        cx(Styles.sliderContainerHandle, Styles.sliderContainerHandleBB,
                            {
                                [Styles.sliderContainerHandleLow]: min === max
                            })
                    }>
                        <div className={
                            cx(Styles.sliderContainerHandleTitle, Styles.sliderContainerHandleTitleBB,
                                {
                                    [Styles.sliderContainerHandleTitleLow]: min === max
                                })
                        }>
                            <div className={Styles.sliderContainerHandleTitleDesktop}>{title}</div>
                        </div>
                        <div className={Styles.sliderContainerHandleValue}>
                            {impressions}<span className={Styles.sliderContainerHandleValueCurrency}>{currency}</span>
                        </div>
                        <div className={
                            cx(Styles.sliderContainerHandleArrow, Styles.sliderContainerHandleArrowBB,
                                {
                                    [Styles.sliderContainerHandleArrowGrey]: min === max
                                })
                        }/>
                    </div>}
            >
                <Handle value={value} {...restProps} />
            </Tooltip>
        );
    }

    _setMonths(value){
        try {
            this.setState({months: value, leads: this.state.leads});
        } catch (e) {}
    }

    _renderLeadsByMonth() {
        try {
            let budget = JSON.parse(this.state["spend_" + this.state.market.toLowerCase() + "_" + this.state.lang.toLowerCase()].value).spend;
            let price = 0; // starting price qualified leads
            let months = this.state.months;
            let subscription = this.state.tab;
            let result_low = 0;
            let result_high = 0;
            let market_factor = 0;
            let leads_month = 0;

            if (this.state.market.toLowerCase() === "se") {
                market_factor = 0.5;
                price = 320;
            } else {
                market_factor = 1;
                price = 320;
            }

            if (subscription === "enterprise") {
                leads_month = (budget / price) * (1 + (months * (budget < 30000 ? 0.15 : 0.10)));
                result_low = Math.round((leads_month) * 0.85);
                result_high = Math.round((leads_month) * 1.15);
            } else {
                leads_month = (budget / price) * (1 + (months * (budget < 30000 ? 0.05 : 0.03)));
                result_low = Math.round((leads_month) * 0.85);
                result_high = Math.round((leads_month) * 1.20);
            }

            return result_low + "-" + result_high;
    } catch (e) {}
    }

    _renderPercentage(data) {
    let percentage = data / this.state.max_months;
    let subscription = this.state.tab;

        if (subscription === "enterprise") {
            percentage = 25 + (percentage * 55);
        } else {
            percentage = 15 + (percentage * 35);
        }

    if (percentage > 99) {
        return 99;
    } else {
        return Math.floor(percentage);
    }
    }

    render() {
        return (
            <div>
                <Element name="top" className="top"></Element>
                {
                    this.state.brandingSuccess &&
                    <BoosterHeaderBranding lang={this.state.lang} market={this.state.market} history={this.props.history} website={this.state.reseller_website} logo={this.state.reseller_logo} favicon={this.state.reseller_favicon}/>
                }
                {
                    !this.renders.branding() &&
                    <BoosterHeader lang={this.state.lang} market={this.state.market} history={this.props.history}/>
                }
                <div /*style={(this.renders.branding() && this.state.reseller_background) ? { backgroundImage: 'url(' + this.state.reseller_background + ')', backgroundRepeat: 'space', backgroundSize: 'auto'} : {}}*/
                    className={
                    cx(Styles.header,
                        {
                            [Styles.headerPB]: this.renderPropertyBooster() && !this.renders.branding(),
                            [Styles.headerBB]: this.renderBoostaBostad() && !this.renders.branding(),
                            [Styles.headerYL]: this.renderYieldlock() && !this.renders.branding(),
                            [Styles.headerYS]: this.renderYieldspotter() && !this.renders.branding(),
                            [Styles.headerBranding]: this.renders.branding(),
                            [Styles.headerOpen]: (this.state.search !== '' || this.state.beds.first || this.state.beds.second),
                            [Styles.headerFull]: this.renders.platformTeaser() && !this.renders.newsFeed(),
                            [Styles.headerNewsFeed]: this.renders.platformTeaser() && this.renders.newsFeed(),
                        })
                }>
                    <div className={
                        cx(Styles.container,
                            {
                                [Styles.headerFull]: this.renders.platformTeaser(),
                            })
                    }>
                        {
                            !this.renders.branding() &&
                        <div style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                             className={cx(Styles.headerTitle,
                                 {
                                     [Styles.headerTitlePreview]: this.renders.platformTeaser(),
                                 })
                             }>
                            {
                                !this.renders.platformTeaser() && !this.renderYieldlock() && !this.renderYieldspotter() &&
                                <span className={Styles.headerTitleBold}>
                                    {this.renders.text("item_15")}&nbsp;
                                </span>
                            }
                            {
                                !this.renders.platformTeaser() && (this.renderYieldlock() || this.renderYieldspotter()) &&
                                <span className={Styles.headerTitleTypist}>
                                    {this.renders.text("item_23")}&nbsp;
                                </span>
                            }
                            {
                                this.renders.platformTeaser() &&
                                <span className={Styles.headerTitleBold}>
                                    {this.renders.text("item_19")}&nbsp;
                                </span>
                            }
                            {
                                !this.renders.platformTeaser() && !this.renderYieldlock() && !this.renderYieldspotter() &&
                                <div className={Styles.headerTitleTypist}>
                                    {this.renders.text("item_16")}
                                </div>
                            }
                            {
                                !this.renders.platformTeaser() && (this.renderYieldlock() || this.renderYieldspotter()) &&
                                <div className={Styles.headerTitleBold}>
                                    {this.renders.text("item_24")}
                                </div>
                            }
                            {
                                this.renders.platformTeaser() &&
                                <div className={Styles.headerTitleTypist}>
                                    {this.renders.text("item_20")}
                                </div>
                            }
                        </div>
                        }
                        {
                            this.renders.platformTeaser() &&
                            <a className={Styles.liveButtonLink}
                               href={"https://app." + (dataRegister.getDomain() === "devyieldspotter.com" ? "devyieldlock.com" : dataRegister.getDomain() === "yieldspotter.com" ? "yieldlock.com" : dataRegister.getDomain()) + '/' + this.state.market + '/' + this.state.lang + '/register'}>
                                <div
                                    style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#E65032'} : {}}
                                    className={Styles.liveButton}>
                                    {this.renders.text("item_22")}
                                </div>
                            </a>
                        }
                        {
                            !this.renders.platformTeaser() &&
                            <div className={Styles.headerOptions}>
                                {
                                    !this.state.error &&
                                    this.state.types.map((item) => {
                                        return (
                                            <div
                                                style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                onClick={() => this.functions.selectType(item)} className={
                                                cx(Styles.headerOptionsItem,
                                                    {
                                                        [Styles.headerOptionsItemFaded]: !item.selected && !this.renderYieldlock() && !this.renderYieldspotter(),
                                                        [Styles.headerOptionsItemFadedYL]: !item.selected && (this.renderYieldlock() || this.renderYieldspotter()),
                                                    })
                                            }>
                                                {item.title}
                                                {
                                                    item.selected &&
                                                    <div
                                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#E65032'} : (this.renders.branding() && this.renders.brandingPrimaryColor()) ? { border: this.renders.brandingPrimaryColor(), backgroundColor: this.renders.brandingPrimaryColor()} : {}}
                                                        className={Styles.headerOptionsItemMarker}/>
                                                }
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        }
                        {
                            !this.renders.platformTeaser() &&
                            <div className={Styles.headerOptionsMobile}>
                                <select
                                    value={this.state.type_value}
                                    className={Styles.headerOptionsMobileDropdown}
                                    onChange={(event) => this.functions.selectTypeMobile(event.target.value)}
                                >
                                    {
                                        this.state.types.map((item) => {
                                            return (
                                                <option value={JSON.stringify(item)}>{item.title}</option>
                                            )
                                        })
                                    }
                                </select>
                                {
                                    (!this.renderYieldlock() && !this.renderYieldspotter()) &&
                                    <img className={Styles.headerOptionsMobileArrow}
                                         src={require('../../assets/images/arrow-down.svg')}/>
                                }
                                {
                                    (this.renderYieldlock() || this.renderYieldspotter()) &&
                                    <img className={Styles.headerOptionsMobileArrow}
                                         src={require('../../assets/images/arrow-down_yl.svg')}/>
                                }
                                <div
                                    style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                    className={cx(Styles.headerOptionsMobileValue)}>
                                    {this.renders.type()}
                                    <div
                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#E65032'} : (this.renders.branding() && this.renders.brandingPrimaryColor()) ? { border: this.renders.brandingPrimaryColor(), backgroundColor: this.renders.brandingPrimaryColor()} : {}}
                                        className={Styles.headerOptionsItemMarker}/>
                                </div>
                            </div>
                        }
                        {
                            !this.renders.platformTeaser() &&
                            <div className={Styles.headerSearch}>
                                <Element name="search" className="searchInput">
                                    <div id="section1" className={Styles.headerSearchContainer}>
                                        <img className={Styles.headerSearchContainerFront}
                                             src={require('../../assets/images/arrow_front.png')}/>
                                        <input
                                            onFocus={() => this.setState({open: true}, () => {
                                                if (window.innerWidth > 1050) {
                                                    scroller.scrollTo('top', {
                                                        duration: 600,
                                                        delay: 0,
                                                        offset: 150,
                                                        smooth: 'easeInOutQuart'
                                                    })
                                                }
                                            })}
                                            autoComplete="off"
                                            spellCheck="false"
                                            autoCorrect="off"
                                            ref={"input"}
                                            value={this.state.search}
                                            placeholder={this.renders.text("item_36")}
                                            onChange={(event) => this.setState({search: event.target.value})}
                                            style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : (this.renders.branding() && this.renders.brandingPrimaryColor() && this.state.error) ? { border: this.renders.brandingPrimaryColor(), color: this.renders.brandingPrimaryColor()} : {}}
                                            className={
                                                cx(Styles.headerSearchInput,
                                                    {
                                                        [Styles.headerSearchInputError]: this.state.error && !this.renderYieldlock() && !this.renderYieldspotter() && !this.renders.branding(),
                                                        [Styles.headerSearchInputErrorYL]: this.state.error && (this.renderYieldlock() || this.renderYieldspotter()),
                                                    })
                                            }
                                        />
                                        {
                                            this.state.isLoading &&
                                            <div className={Styles.headerSearchContainerOverlay}>
                                                <BeatLoader size={25} color={this.renderLoader()} loading={true}/>
                                            </div>
                                        }
                                    </div>
                                </Element>
                                <div style={this.state.isLoading ? {opacity: "0"} : {}}
                                     className={Styles.headerSearchContainerFilter}>
                                    <div className={
                                        cx(Styles.headerSearchContainerFilterColumn,
                                            {
                                                [Styles.headerSearchContainerFilterColumnOpen]: this.state.search === "" && !this.state.beds.first && !this.state.beds.second,
                                            })
                                    }>
                                        <div className={
                                            cx(Styles.headerSearchContainerFilterMobile,
                                                {
                                                    [Styles.headerSearchContainerFilterMobileHide]: this.state.search === '' && !this.state.beds.first && !this.state.beds.second,
                                                })
                                        }>
                                            {
                                                <div className={Styles.clearDesktop}>
                                                    <div onClick={() => this.functions.clear()}
                                                         className={cx(Styles.headerSearchContainerFilterResultMobile, Styles.headerSearchContainerFilterResultMobileDesktop,
                                                             {
                                                                 [Styles.headerSearchContainerFilterResultMobilePB]: this.renderPropertyBooster(),
                                                                 [Styles.headerSearchContainerFilterResultMobileBB]: this.renderBoostaBostad(),
                                                                 [Styles.headerSearchContainerFilterResultMobileYL]: (this.renderYieldlock() || this.renderYieldspotter()),
                                                                 [Styles.headerSearchContainerFilterResultMobileDesktopClear]: (this.renderPropertyBooster() || this.renderBoostaBostad()),
                                                                 [Styles.headerSearchContainerFilterResultMobileDesktopClearYL]: (this.renderYieldlock() || this.renderYieldspotter()),
                                                             })
                                                         }>
                                                        {this.renders.text("item_37")}
                                                    </div>
                                                </div>
                                            }
                                            {
                                                <div onClick={() => {
                                                    scroller.scrollTo('searchInput', {
                                                        duration: 600,
                                                        offset: 95,
                                                        delay: 0,
                                                        smooth: 'easeInOutQuart'
                                                    })
                                                }}
                                                     style={(this.renders.branding() && this.renders.brandingPrimaryColor()) ? { border: this.renders.brandingPrimaryColor(), backgroundColor: this.renders.brandingPrimaryColor()} : {}}
                                                     className={cx(Styles.headerSearchContainerFilterResultMobile, Styles.headerSearchContainerFilterResultMobileDesktop,
                                                         {
                                                             [Styles.headerSearchContainerFilterResultMobilePB]: this.renderPropertyBooster() && !this.renders.branding(),
                                                             [Styles.headerSearchContainerFilterResultMobileBB]: this.renderBoostaBostad() && !this.renders.branding(),
                                                             [Styles.headerSearchContainerFilterResultMobileYL]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.renders.branding()
                                                     })
                                                     }>
                                                    {this.renders.text("item_39")} {this.filters.listings().length}
                                                </div>
                                            }
                                            <div
                                                style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                className={cx(Styles.headerSearchContainerFilterSortMobile)}>
                                                <div>{this.renders.text("item_38")} {this.renders.sort()}</div>
                                                <select
                                                    value={this.state.sort_value}
                                                    className={Styles.headerSearchContainerFilterDropdownBottomFilterDropdown}
                                                    onChange={(event) => this.functions.setSort(event.target.value)}
                                                >
                                                    {
                                                        this.state.sort.map((item) => {
                                                            return (
                                                                <option
                                                                    value={JSON.stringify(item)}>{item.title}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                        <div className={Styles.headerSearchContainerFilterInner}>
                                            {
                                                (this.state.search !== '' || this.state.beds.first || this.state.beds.second) &&
                                                <div className={
                                                    cx(Styles.headerSearchContainerFilterMobile, Styles.headerSearchContainerFilterMobileTop,
                                                        {
                                                            [Styles.headerSearchContainerFilterMobileHide]: this.state.search === '' && !this.state.beds.first && !this.state.beds.second,
                                                        })
                                                }>
                                                    {
                                                        <div onClick={() => {
                                                            scroller.scrollTo('priceMobile', {
                                                                duration: 600,
                                                                delay: 0,
                                                                offset: -15,
                                                                smooth: 'easeInOutQuart'
                                                            })
                                                        }}
                                                             style={(this.renders.branding() && this.renders.brandingPrimaryColor()) ? { border: this.renders.brandingPrimaryColor(), backgroundColor: this.renders.brandingPrimaryColor()} : {}}
                                                             className={cx(Styles.headerSearchContainerFilterResultMobile, Styles.headerSearchContainerFilterResultMobileTop,
                                                                 {
                                                                     [Styles.headerSearchContainerFilterResultMobilePB]: this.renderPropertyBooster() && !this.renders.branding(),
                                                                     [Styles.headerSearchContainerFilterResultMobileBB]: this.renderBoostaBostad() && !this.renders.branding(),
                                                                     [Styles.headerSearchContainerFilterResultMobileYL]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.renders.branding(),
                                                                     [Styles.headerSearchContainerFilterResultMobileTopPB]: this.renderPropertyBooster() && !this.renders.branding(),
                                                                     [Styles.headerSearchContainerFilterResultMobileTopBB]: this.renderBoostaBostad() && !this.renders.branding(),
                                                                     [Styles.headerSearchContainerFilterResultMobileTopYL]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.renders.branding(),
                                                                 })
                                                             }>
                                                            {this.renders.text("item_39")} {this.filters.listings().length}
                                                        </div>
                                                    }
                                                    {
                                                        <div onClick={() => this.functions.clear()}
                                                             className={cx(Styles.headerSearchContainerFilterResultMobile, Styles.headerSearchContainerFilterResultMobileTop,
                                                                 {
                                                                     [Styles.headerSearchContainerFilterResultMobilePB]: this.renderPropertyBooster(),
                                                                     [Styles.headerSearchContainerFilterResultMobileBB]: this.renderBoostaBostad(),
                                                                     [Styles.headerSearchContainerFilterResultMobileYL]: (this.renderYieldlock() || this.renderYieldspotter()),
                                                                     [Styles.headerSearchContainerFilterResultMobileTopPB]: this.renderPropertyBooster(),
                                                                     [Styles.headerSearchContainerFilterResultMobileTopBB]: this.renderBoostaBostad(),
                                                                     [Styles.headerSearchContainerFilterResultMobileTopYL]: (this.renderYieldlock() || this.renderYieldspotter()),
                                                                     [Styles.headerSearchContainerFilterResultMobileTopClear]: (this.renderPropertyBooster() || this.renderBoostaBostad()),
                                                                     [Styles.headerSearchContainerFilterResultMobileTopClearYL]: (this.renderYieldlock() || this.renderYieldspotter()),
                                                                 })
                                                             }>
                                                            {this.renders.text("item_37")}
                                                        </div>
                                                    }
                                                </div>
                                            }
                                            <div className={Styles.headerSearchContainerFilterPrice}>
                                                <div
                                                    style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                    className={Styles.headerSearchContainerFilterPriceItem}>
                                                    <div>  {this.state.currency}{" "}{this.renders.numbers(this.renders.price(this.state.price_range[0]))}</div>
                                                    {
                                                        false &&
                                                        <select
                                                            value={this.state.min_price}
                                                            className={Styles.headerSearchContainerFilterDropdownBottomFilterDropdown}
                                                            onChange={(event) => this.functions.setMinPrice(event.target.value)}
                                                        >
                                                            {
                                                                this.state.min_prices.map((item) => {
                                                                    return (
                                                                        <option disabled={item.disabled}
                                                                                value={JSON.stringify(item)}>{this.state.currency}{' '}{this.renders.numbers(this.renders.price(item.price))}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    }
                                                </div>
                                                <div onTouchEnd={() => {
                                                    if (this.state.first_drag && this.state.search === '' /*&& window.innerWidth < 1050*/) {
                                                        this.state.beds.first = 1;
                                                        this.state.beds.second = 5;
                                                        this.setState({beds: this.state.beds, first_drag: false});
                                                    }
                                                }} onMouseUp={() => {
                                                    if (this.state.first_drag && this.state.search === '' && window.innerWidth > 1050) {
                                                        this.state.beds.first = 1;
                                                        this.state.beds.second = 5;
                                                        this.setState({beds: this.state.beds, first_drag: false});
                                                    }
                                                }} className={Styles.headerSearchContainerFilterPriceSlider}>
                                                    <Element name="priceMobile" className="priceMobile">
                                                        <div className={Styles.headerSearchContainerFilterPriceSliderInner}>
                                                            {
                                                                <Range
                                                                    step={1}
                                                                    defaultValue={this.state.default}
                                                                    trackStyle={[{backgroundColor: this.renderLoader()}]}
                                                                    handleStyle={[{backgroundColor: this.renderLoader()}, {backgroundColor: this.renderLoader()}]}
                                                                    min={this.state.min}
                                                                    max={this.state.max}
                                                                    value={this.state.price_range}
                                                                    onChange={(value) => {
                                                                        console.log(value);
                                                                        this.setState({price_range: value});
                                                                    }}
                                                                />
                                                            }
                                                        </div>
                                                        <div
                                                            className={Styles.headerSearchContainerFilterPriceSliderLine}/>
                                                    </Element>
                                                </div>
                                                <div
                                                    style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                    className={Styles.headerSearchContainerFilterPriceItem}>
                                                    <div>  {this.state.currency}{" "}{this.renders.numbers(this.renders.price(this.state.price_range[1]))}</div>
                                                    {
                                                        false &&
                                                        <select
                                                            value={this.state.max_price}
                                                            className={Styles.headerSearchContainerFilterDropdownBottomFilterDropdown}
                                                            onChange={(event) => this.functions.setMaxPrice(event.target.value)}
                                                        >
                                                            {
                                                                this.state.max_prices.map((item) => {
                                                                    return (
                                                                        <option disabled={item.disabled}
                                                                                value={JSON.stringify(item)}>{this.state.currency}{' '}{this.renders.numbers(this.renders.price(item.price))}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    }
                                                </div>
                                            </div>
                                            <div className={Styles.headerSearchContainerFilterPriceMobile}>
                                                <div
                                                    style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                    className={Styles.headerSearchContainerFilterPriceMobileItem}>
                                                    <div>  {this.state.currency}{" "}{this.renders.numbers(this.renders.price(this.state.price_range[0]))}</div>
                                                    {
                                                        false &&
                                                        <select
                                                            value={this.state.min_price}
                                                            className={Styles.headerSearchContainerFilterDropdownBottomFilterDropdown}
                                                            onChange={(event) => this.functions.setMinPrice(event.target.value)}
                                                        >
                                                            {
                                                                this.state.min_prices.map((item) => {
                                                                    return (
                                                                        <option disabled={item.disabled}
                                                                                value={JSON.stringify(item)}>{this.state.currency}{' '}{this.renders.numbers(this.renders.price(item.price))}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    }
                                                </div>
                                                <div
                                                    style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                    className={Styles.headerSearchContainerFilterPriceMobileItem}>
                                                    <div>  {this.state.currency}{" "}{this.renders.numbers(this.renders.price(this.state.price_range[1]))}</div>
                                                    {
                                                        false &&
                                                        <select
                                                            value={this.state.max_price}
                                                            className={Styles.headerSearchContainerFilterDropdownBottomFilterDropdown}
                                                            onChange={(event) => this.functions.setMaxPrice(event.target.value)}
                                                        >
                                                            {
                                                                this.state.max_prices.map((item) => {
                                                                    return (
                                                                        <option disabled={item.disabled}
                                                                                value={JSON.stringify(item)}>{this.state.currency}{' '}{this.renders.numbers(this.renders.price(item.price))}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    }
                                                </div>
                                            </div>
                                            <div className={Styles.headerSearchContainerFilterBeds}>
                                                {
                                                    <div className={
                                                        cx(Styles.headerSearchContainerFilterBedsItemSelected,
                                                            {
                                                                /*
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedSingle]: this.state.beds.first && !this.state.beds.second,
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedSingleZero]: this.state.beds.first === 1 && !this.state.beds.second,
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedSingleOne]: this.state.beds.first === 2 && !this.state.beds.second,
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedSingleTwo]: this.state.beds.first === 3 && !this.state.beds.second,
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedSingleThree]: this.state.beds.first === 4 && !this.state.beds.second,
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedSingleFour]: this.state.beds.first === 5 && !this.state.beds.second,
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedDouble]: this.state.beds.first && this.state.beds.second && (this.state.beds.first - this.state.beds.second === 1 || this.state.beds.first - this.state.beds.second === -1),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedDoubleZeroAndOne]: (this.state.beds.first === 1 && this.state.beds.second === 2) || (this.state.beds.first === 2 && this.state.beds.second === 1),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedDoubleOneAndTwo]: (this.state.beds.first === 2 && this.state.beds.second === 3) || (this.state.beds.first === 3 && this.state.beds.second === 2),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedDoubleTwoAndThree]: (this.state.beds.first === 3 && this.state.beds.second === 4) || (this.state.beds.first === 4 && this.state.beds.second === 3),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedDoubleThreeAndFour]: (this.state.beds.first === 4 && this.state.beds.second === 5) || (this.state.beds.first === 5 && this.state.beds.second === 4),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedTripple]: this.state.beds.first && this.state.beds.second && (this.state.beds.first - this.state.beds.second === 2 || this.state.beds.first - this.state.beds.second === -2),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedTrippleZeroAndTwo]: (this.state.beds.first === 1 && this.state.beds.second === 3) || (this.state.beds.first === 3 && this.state.beds.second === 1),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedTrippleOneAndThree]: (this.state.beds.first === 2 && this.state.beds.second === 4) || (this.state.beds.first === 4 && this.state.beds.second === 2),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedTrippleTwoAndFour]: (this.state.beds.first === 3 && this.state.beds.second === 5) || (this.state.beds.first === 5 && this.state.beds.second === 3),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedQuadruple]: this.state.beds.first && this.state.beds.second && (this.state.beds.first - this.state.beds.second === 3 || this.state.beds.first - this.state.beds.second === -3),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedQuadrupleOneAndFour]: (this.state.beds.first === 2 && this.state.beds.second === 5) || (this.state.beds.first === 5 && this.state.beds.second === 2),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedQuadrupleZeroAndThree]: (this.state.beds.first === 1 && this.state.beds.second === 4) || (this.state.beds.first === 4 && this.state.beds.second === 1),
                                                                [Styles.headerSearchContainerFilterBedsItemSelectedPenta]: this.state.beds.first && this.state.beds.second && (this.state.beds.first - this.state.beds.second === 4 || this.state.beds.first - this.state.beds.second === -4),
                                                                */
                                                            })
                                                    }/>
                                                }
                                                <div className={
                                                    cx(Styles.headerSearchContainerFilterBedsItem, Styles.headerSearchContainerFilterBedsItemStudio,
                                                        {
                                                            [Styles.headerSearchContainerFilterBedsItemDisabled]: this.renders.beds(1),
                                                            [Styles.headerSearchContainerFilterBedsItemBackground]:
                                                            (this.state.beds.first === 1 && !this.state.beds.second) ||
                                                            (this.state.beds.first === 1 && this.state.beds.second > 1 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                            (this.state.beds.first > 1 && this.state.beds.second === 1 && this.state.beds.first !== null && this.state.beds.second !== null),
                                                        })
                                                } onClick={() => {
                                                    if (!this.renders.beds(1)) {
                                                        this.functions.selectBeds(1)
                                                    }
                                                }}>
                                                    <div
                                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                        className={Styles.headerSearchContainerFilterBedsItemInner}>
                                                        {this.renders.text("item_40")}
                                                    </div>
                                                    {
                                                        false && this.state.beds.first === 1 && !this.state.beds.second &&
                                                        <div
                                                            className={cx(Styles.headerSearchContainerFilterBedsItemSelectedNew, Styles.headerSearchContainerFilterBedsItemSelectedNewStudio)}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first === 1 && this.state.beds.second > 1 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewStudio,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewFirst
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first > 1 && this.state.beds.second === 1 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewStudio,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewFirst
                                                        )}/>
                                                    }
                                                </div>
                                                <div onClick={() => {
                                                    if (!this.renders.beds(1)) {
                                                        this.functions.selectBeds(2)
                                                    }
                                                }}
                                                     className={
                                                         cx(Styles.headerSearchContainerFilterBedsItem,
                                                             {
                                                                 [Styles.headerSearchContainerFilterBedsItemDisabled]: this.renders.beds(1),
                                                                 [Styles.headerSearchContainerFilterBedsItemBackground]: (this.state.beds.first === 2 && !this.state.beds.second) ||
                                                                 (this.state.beds.first === 1 && this.state.beds.second === 2 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first === 2 && this.state.beds.second === 1 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first === 2 && this.state.beds.second > 2 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first > 2 && this.state.beds.second === 2 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first < 2 && this.state.beds.second > 2 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first > 2 && this.state.beds.second < 2 && this.state.beds.first !== null && this.state.beds.second !== null)
                                                             })
                                                     }>
                                                    <div
                                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                        className={Styles.headerSearchContainerFilterBedsItemInner}>
                                                        1
                                                    </div>
                                                    {
                                                        false && this.state.beds.first === 2 && !this.state.beds.second &&
                                                        <div
                                                            className={Styles.headerSearchContainerFilterBedsItemSelectedNew}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first === 1 && this.state.beds.second === 2 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewLast
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first === 2 && this.state.beds.second === 1 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewLast
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first === 2 && this.state.beds.second > 2 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewFirst
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first > 2 && this.state.beds.second === 2 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewFirst
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first < 2 && this.state.beds.second > 2 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewCenter
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first > 2 && this.state.beds.second < 2 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewCenter
                                                        )}/>
                                                    }
                                                </div>
                                                <div onClick={() => {
                                                    if (!this.renders.beds(2)) {
                                                        this.functions.selectBeds(3)
                                                    }
                                                }}
                                                     className={
                                                         cx(Styles.headerSearchContainerFilterBedsItem,
                                                             {
                                                                 [Styles.headerSearchContainerFilterBedsItemDisabled]: this.renders.beds(2),
                                                                 [Styles.headerSearchContainerFilterBedsItemBackground]: (this.state.beds.first === 3 && !this.state.beds.second) ||
                                                                 (this.state.beds.first < 3 && this.state.beds.second === 3 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first === 3 && this.state.beds.second < 3 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first === 3 && this.state.beds.second > 3 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first > 3 && this.state.beds.second === 3 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first < 3 && this.state.beds.second > 3 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first > 3 && this.state.beds.second < 3 && this.state.beds.first !== null && this.state.beds.second !== null)
                                                             })
                                                     }>
                                                    <div
                                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                        className={Styles.headerSearchContainerFilterBedsItemInner}>
                                                        2
                                                    </div>
                                                    {
                                                        false && this.state.beds.first === 3 && !this.state.beds.second &&
                                                        <div
                                                            className={Styles.headerSearchContainerFilterBedsItemSelectedNew}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first < 3 && this.state.beds.second === 3 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewLast
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first === 3 && this.state.beds.second < 3 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewLast
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first === 3 && this.state.beds.second > 3 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewFirst
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first > 3 && this.state.beds.second === 3 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewFirst
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first < 3 && this.state.beds.second > 3 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewCenter
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first > 3 && this.state.beds.second < 3 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewCenter
                                                        )}/>
                                                    }
                                                </div>
                                                <div onClick={() => {
                                                    if (!this.renders.beds(3)) {
                                                        this.functions.selectBeds(4)
                                                    }
                                                }}
                                                     className={
                                                         cx(Styles.headerSearchContainerFilterBedsItem,
                                                             {
                                                                 [Styles.headerSearchContainerFilterBedsItemDisabled]: this.renders.beds(3),
                                                                 [Styles.headerSearchContainerFilterBedsItemBackground]: (this.state.beds.first === 4 && !this.state.beds.second) ||
                                                                 (this.state.beds.first === 4 && this.state.beds.second < 4 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first < 4 && this.state.beds.second === 4 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first === 4 && this.state.beds.second > 4 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first > 4 && this.state.beds.second === 4 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first < 4 && this.state.beds.second > 4 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first > 4 && this.state.beds.second < 4 && this.state.beds.first !== null && this.state.beds.second !== null)
                                                             })
                                                     }>
                                                    <div
                                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                        className={Styles.headerSearchContainerFilterBedsItemInner}>
                                                        3
                                                    </div>
                                                    {
                                                        false && this.state.beds.first === 4 && !this.state.beds.second &&
                                                        <div
                                                            className={Styles.headerSearchContainerFilterBedsItemSelectedNew}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first === 4 && this.state.beds.second < 4 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewLast
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first < 4 && this.state.beds.second === 4 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewLast
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first === 4 && this.state.beds.second > 4 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewFirst
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first > 4 && this.state.beds.second === 4 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewFirst
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first < 4 && this.state.beds.second > 4 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewCenter
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first > 4 && this.state.beds.second < 4 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewCenter
                                                        )}/>
                                                    }
                                                </div>
                                                <div onClick={() => {
                                                    if (!this.renders.beds(4)) {
                                                        this.functions.selectBeds(5)
                                                    }
                                                }}
                                                     className={
                                                         cx(Styles.headerSearchContainerFilterBedsItem,
                                                             {
                                                                 [Styles.headerSearchContainerFilterBedsItemDisabled]: this.renders.beds(4),
                                                                 [Styles.headerSearchContainerFilterBedsItemBackground]: (this.state.beds.first > 4 && !this.state.beds.second) ||
                                                                 (this.state.beds.first > 4 && this.state.beds.second < 5 && this.state.beds.first !== null && this.state.beds.second !== null) ||
                                                                 (this.state.beds.first < 5 && this.state.beds.second > 4 && this.state.beds.first !== null && this.state.beds.second !== null)
                                                             })
                                                     }>
                                                    <div
                                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                        className={Styles.headerSearchContainerFilterBedsItemInner}>
                                                        4+
                                                    </div>
                                                    {
                                                        false && this.state.beds.first > 4 && !this.state.beds.second &&
                                                        <div
                                                            className={Styles.headerSearchContainerFilterBedsItemSelectedNew}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first > 4 && this.state.beds.second < 5 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewLast
                                                        )}/>
                                                    }
                                                    {
                                                        false && this.state.beds.first < 5 && this.state.beds.second > 4 && this.state.beds.first !== null && this.state.beds.second !== null &&
                                                        <div className={cx(
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNew,
                                                            Styles.headerSearchContainerFilterBedsItemSelectedNewLast
                                                        )}/>
                                                    }
                                                </div>
                                            </div>
                                            {
                                                (this.state.search !== '' || this.state.beds.first || this.state.beds.second) &&
                                                <div
                                                    className={cx(Styles.headerSearchContainerFilterPrice, Styles.headerSearchContainerFilterPriceFilterMobile)}>
                                                    <div
                                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                        className={cx(Styles.headerSearchContainerFilterSortMobile, Styles.headerSearchContainerFilterSortMobileNew)}>
                                                        <div>{this.renders.text("item_38")} {this.renders.sort()}</div>
                                                        <select
                                                            value={this.state.sort_value}
                                                            className={Styles.headerSearchContainerFilterDropdownBottomFilterDropdown}
                                                            onChange={(event) => this.functions.setSort(event.target.value)}
                                                        >
                                                            {
                                                                this.state.sort.map((item) => {
                                                                    return (
                                                                        <option
                                                                            value={JSON.stringify(item)}>{item.title}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {
                                        (this.state.search !== '' || this.state.beds.first || this.state.beds.second) &&
                                        <div className={Styles.headerSearchContainerFilterDropdown}>
                                            <div className={Styles.headerSearchContainerFilterDropdownInner}>
                                                {
                                                    this.filters.limit(this.sort.listings(this.filters.listings())).map((item) => {
                                                        return (
                                                            <div onClick={() => this.functions.link(item.id)}
                                                                 className={Styles.headerSearchContainerFilterDropdownItem}>
                                                                <div
                                                                    className={Styles.headerSearchContainerFilterDropdownItemImage}>
                                                                    <div
                                                                        style={{backgroundImage: "url(" + item.image0 + ")"}}
                                                                        className={Styles.headerSearchContainerFilterDropdownItemImageInner}/>
                                                                    <div
                                                                        className={Styles.headerSearchContainerFilterDropdownItemImageLoader}>
                                                                        <BeatLoader size={15}
                                                                                    color={this.renderLoader()}
                                                                                    loading={true}/>
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={Styles.headerSearchContainerFilterDropdownItemInformation}>
                                                                    <div
                                                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                                        className={
                                                                            cx(Styles.headerSearchContainerFilterDropdownItemInformationTitle,
                                                                                {
                                                                                    [Styles.headerSearchContainerFilterDropdownItemInformationTitleSmall]: this.state.format_small,
                                                                                })
                                                                        }>
                                                                        {item.industry[this.state.lang]}
                                                                    </div>
                                                                    <div
                                                                        style={(this.renders.branding() && this.renders.brandingPrimaryColor()) ? { color: this.renders.brandingPrimaryColor()} : {}}
                                                                        className={cx(Styles.headerSearchContainerFilterDropdownItemInformationPrice,
                                                                            {
                                                                                [Styles.headerSearchContainerFilterDropdownItemInformationPriceSmall]: this.state.format_small,
                                                                                [Styles.headerSearchContainerFilterDropdownItemInformationPricePB]: this.renderPropertyBooster() && !this.renders.branding(),
                                                                                [Styles.headerSearchContainerFilterDropdownItemInformationPriceBB]: this.renderBoostaBostad() && !this.renders.branding(),
                                                                                [Styles.headerSearchContainerFilterDropdownItemInformationPriceYL]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.renders.branding()
                                                                            })
                                                                        }>
                                                                        {item.price > 0 ? (this.state.currency ? this.state.currency.toUpperCase() : this.state.currency) : ''}{item.price > 0 ? ' ' : ''}{item.price > 0 ? this.renders.numbers(this.renders.price(item.price)) : this.renders.text("item_2")}
                                                                        {
                                                                            item.identifier === 'rent' && item.price > 0 &&
                                                                            <span>{' '}{item.duration}</span>
                                                                        }
                                                                    </div>
                                                                    <div
                                                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                                        className={
                                                                            cx(Styles.headerSearchContainerFilterDropdownItemInformationLocation,
                                                                                {
                                                                                    [Styles.headerSearchContainerFilterDropdownItemInformationLocationSmall]: this.state.format_small,
                                                                                })
                                                                        }>
                                                                        {item.location}{this.renders.address(item.address, item.location)}
                                                                    </div>
                                                                    <div
                                                                        className={Styles.headerSearchContainerFilterDropdownItemInformationLast}>
                                                                        {
                                                                            !this.renderYieldlock() && !this.renderYieldspotter() &&
                                                                            <div
                                                                                style={(this.renders.branding() && this.renders.brandingPrimaryColor()) ? { backgroundColor: this.renders.brandingPrimaryColor()} : {}}
                                                                                className={
                                                                                    cx(Styles.headerSearchContainerFilterDropdownItemInformationLastSlogan,
                                                                                        {
                                                                                            [Styles.headerSearchContainerFilterDropdownItemInformationLastSloganSmall]: this.state.format_small,
                                                                                        })
                                                                                }>
                                                                                {item.slogans[0]}
                                                                            </div>
                                                                        }
                                                                        {
                                                                            (this.renderYieldlock() || this.renderYieldspotter()) &&
                                                                            <div
                                                                                style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#00273A'} : {}}
                                                                                className={
                                                                                    cx(Styles.headerSearchContainerFilterDropdownItemInformationLastSlogan,
                                                                                        {
                                                                                            [Styles.headerSearchContainerFilterDropdownItemInformationLastSloganSmall]: this.state.format_small,
                                                                                        })
                                                                                }>
                                                                                {item.website_advertiser}
                                                                            </div>
                                                                        }
                                                                        {
                                                                            item.impressions > 0 && !this.renderYieldlock() && !this.renderYieldspotter() && !item.price_change &&
                                                                            <div
                                                                                className={
                                                                                    cx(Styles.headerSearchContainerFilterDropdownItemInformationLastViews,
                                                                                        {
                                                                                            [Styles.headerSearchContainerFilterDropdownItemInformationLastViewsSmall]: this.state.format_small,
                                                                                        })
                                                                                }>
                                                                                {this.renders.numbers(item.impressions)} {this.renders.text("item_1")}
                                                                            </div>
                                                                        }
                                                                        {
                                                                            item.price_change && item.old_price > 0 && this._renderReducedPriceClean(item.old_price, item.price) !== 0 && !this.renderYieldlock() && !this.renderYieldspotter() &&
                                                                            <div
                                                                                className={
                                                                                    cx(Styles.headerSearchContainerFilterDropdownItemInformationLastViews,
                                                                                        {
                                                                                            [Styles.headerSearchContainerFilterDropdownItemInformationLastViewsSmall]: this.state.format_small,
                                                                                        })
                                                                                }>
                                                                                {this._renderReducedPrice(item.old_price, item.price)}
                                                                            </div>
                                                                        }
                                                                        {
                                                                            (this.renderYieldlock() || this.renderYieldspotter()) && this._renderBadge(item.list_price, item.market_price) &&
                                                                            <div
                                                                                style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#E65032'} : {}}
                                                                                className={
                                                                                    cx(Styles.headerSearchContainerFilterDropdownItemInformationLastViews,
                                                                                        {
                                                                                            [Styles.headerSearchContainerFilterDropdownItemInformationLastViewsSmall]: this.state.format_small,
                                                                                        })
                                                                                }>
                                                                                {Math.round((100 - ((this._renderListPrice(item.list_price) / this._renderMarketPrice(item.market_price)) * 100)))}{this.renders.text("item_35")}
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    className={Styles.headerSearchContainerFilterDropdownItemExtra}>
                                                                    <div
                                                                        className={Styles.headerSearchContainerFilterDropdownItemExtraInner}>
                                                                        {
                                                                            this.renders.amenities(item).map((item) => {
                                                                                return (
                                                                                    <div
                                                                                        className={
                                                                                            cx(Styles.headerSearchContainerFilterDropdownItemExtraItem,
                                                                                                {
                                                                                                    [Styles.headerSearchContainerFilterDropdownItemExtraItemSmall]: this.state.format_small,
                                                                                                })
                                                                                        }>{item}</div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {
                                               ((this.state.page_size * this.state.page) < this.filters.listings().length) &&
                                                <div onClick={() => {
                                                    this.setState({page: this.state.page + 1})
                                                }} style={(this.renders.branding() && this.renders.brandingPrimaryColor()) ? { backgroundColor: this.renders.brandingPrimaryColor()} : {}}
                                                     className={cx(Styles.headerSearchContainerFilterDropdownMore,
                                                    {
                                                        [Styles.headerSearchContainerFilterDropdownMorePB]: this.renderPropertyBooster() && !this.renders.branding(),
                                                        [Styles.headerSearchContainerFilterDropdownMoreBB]: this.renderBoostaBostad() && !this.renders.branding(),
                                                        [Styles.headerSearchContainerFilterDropdownMoreYL]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.renders.branding()
                                                    })
                                                }>
                                                    <img className={Styles.headerSearchContainerFilterDropdownMoreIcon}
                                                         src={require('../../assets/images/plus_sign_white_small.png')}/>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                                {
                                    (this.state.search !== '' || this.state.beds.first || this.state.beds.second) &&
                                    <div className={cx(Styles.listingsMobile,
                                        {
                                            [Styles.listingsMobileBranding]: this.renders.branding(),
                                        })
                                    }>
                                        <div className={Styles.headerSearchContainerFilterDropdownInner}>
                                            {
                                                this.filters.limit(this.sort.listings(this.filters.listings())).map((item) => {
                                                    return (
                                                        <div onClick={() => this.functions.link(item.id)}
                                                             className={Styles.headerSearchContainerFilterDropdownItem}>
                                                            <div style={{backgroundImage: "url(" + item.image0 + ")"}}
                                                                 className={Styles.headerSearchContainerFilterDropdownItemImage}>
                                                                <div
                                                                    style={{backgroundImage: "url(" + item.image0 + ")"}}
                                                                    className={Styles.headerSearchContainerFilterDropdownItemImageInner}/>
                                                                <div
                                                                    className={Styles.headerSearchContainerFilterDropdownItemImageLoader}>
                                                                    <BeatLoader size={15} color={this.renderLoader()}
                                                                                loading={true}/>
                                                                </div>
                                                            </div>
                                                            <div
                                                                className={Styles.headerSearchContainerFilterDropdownItemInformation}>
                                                                <div
                                                                    style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                                    className={
                                                                        cx(Styles.headerSearchContainerFilterDropdownItemInformationTitle,
                                                                            {
                                                                                [Styles.headerSearchContainerFilterDropdownItemInformationTitleSmall]: this.state.format_small,
                                                                            })
                                                                    }>
                                                                    {this.renders.industry_mobile(item.industry[this.state.lang])}
                                                                </div>
                                                                <div
                                                                    style={(this.renders.branding() && this.renders.brandingPrimaryColor()) ? { color: this.renders.brandingPrimaryColor()} : {}}
                                                                    className={cx(Styles.headerSearchContainerFilterDropdownItemInformationPrice,
                                                                        {
                                                                            [Styles.headerSearchContainerFilterDropdownItemInformationPriceSmall]: this.state.format_small,
                                                                            [Styles.headerSearchContainerFilterDropdownItemInformationPricePB]: this.renderPropertyBooster() && !this.renders.branding(),
                                                                            [Styles.headerSearchContainerFilterDropdownItemInformationPriceBB]: this.renderBoostaBostad() && !this.renders.branding(),
                                                                            [Styles.headerSearchContainerFilterDropdownItemInformationPriceYL]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.renders.branding()
                                                                        })
                                                                    }>
                                                                    {item.price > 0 ? (this.state.currency ? this.state.currency.toUpperCase() : this.state.currency) : ''}{item.price > 0 ? ' ' : ''}{item.price > 0 ? this.renders.numbers(this.renders.price(item.price)) : this.renders.text("item_2")}
                                                                    {
                                                                        item.identifier === 'rent' && item.price > 0 &&
                                                                        <span>{' '}{item.duration}</span>
                                                                    }
                                                                </div>
                                                                <div
                                                                    style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                                    className={
                                                                        cx(Styles.headerSearchContainerFilterDropdownItemInformationLocation,
                                                                            {
                                                                                [Styles.headerSearchContainerFilterDropdownItemInformationLocationSmall]: this.state.format_small,
                                                                            })
                                                                    }>
                                                                    {item.location}{this.renders.address_mobile(item.address, item.location)}
                                                                </div>
                                                                <div
                                                                    className={Styles.headerSearchContainerFilterDropdownItemInformationLast}>
                                                                    {
                                                                        !this.renderYieldlock() && !this.renderYieldspotter() &&
                                                                        <div
                                                                            style={(this.renders.branding() && this.renders.brandingPrimaryColor()) ? { backgroundColor: this.renders.brandingPrimaryColor()} : {}}
                                                                            className={
                                                                                cx(Styles.headerSearchContainerFilterDropdownItemInformationLastSlogan,
                                                                                    {
                                                                                        [Styles.headerSearchContainerFilterDropdownItemInformationLastSloganSmall]: this.state.format_small,
                                                                                    })
                                                                            }>
                                                                            {item.slogans[0]}
                                                                        </div>
                                                                    }
                                                                    {
                                                                        (this.renderYieldlock() || this.renderYieldspotter()) &&
                                                                        <div
                                                                            style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#00273A'} : {}}
                                                                            className={
                                                                                cx(Styles.headerSearchContainerFilterDropdownItemInformationLastSlogan,
                                                                                    {
                                                                                        [Styles.headerSearchContainerFilterDropdownItemInformationLastSloganSmall]: this.state.format_small,
                                                                                    })
                                                                            }>
                                                                            {item.website_advertiser}
                                                                        </div>
                                                                    }
                                                                    {
                                                                        item.impressions > 0 && !this.renderYieldlock() && !this.renderYieldspotter() && !item.price_change &&
                                                                        <div
                                                                            className={
                                                                                cx(Styles.headerSearchContainerFilterDropdownItemInformationLastViews,
                                                                                    {
                                                                                        [Styles.headerSearchContainerFilterDropdownItemInformationLastViewsSmall]: this.state.format_small,
                                                                                    })
                                                                            }>
                                                                            {this.renders.numbers(item.impressions)} {this.renders.text("item_1")}
                                                                        </div>
                                                                    }
                                                                    {
                                                                        item.price_change && item.old_price > 0 && this._renderReducedPriceClean(item.old_price, item.price) !== 0 && !this.renderYieldlock() && !this.renderYieldspotter() &&
                                                                        <div
                                                                            className={
                                                                                cx(Styles.headerSearchContainerFilterDropdownItemInformationLastViews,
                                                                                    {
                                                                                        [Styles.headerSearchContainerFilterDropdownItemInformationLastViewsSmall]: this.state.format_small,
                                                                                    })
                                                                            }>
                                                                            {this._renderReducedPrice(item.old_price, item.price)}
                                                                        </div>
                                                                    }
                                                                    {
                                                                        (this.renderYieldlock() || this.renderYieldspotter()) && this._renderBadge(item.list_price, item.market_price) &&
                                                                        <div
                                                                            style={this.renderYieldlock() || this.renderYieldspotter() ? {background: '#E65032'} : {}}
                                                                            className={
                                                                                cx(Styles.headerSearchContainerFilterDropdownItemInformationLastViews,
                                                                                    {
                                                                                        [Styles.headerSearchContainerFilterDropdownItemInformationLastViewsSmall]: this.state.format_small,
                                                                                    })
                                                                            }>
                                                                            {Math.round((100 - ((this._renderListPrice(item.list_price) / this._renderMarketPrice(item.market_price)) * 100)))}{this.renders.text("item_35")}
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            {
                                                                window.innerWidth >= 900 &&
                                                                <div
                                                                    className={Styles.headerSearchContainerFilterDropdownItemExtraMobile}>
                                                                    <div
                                                                        className={Styles.headerSearchContainerFilterDropdownItemExtraInner}>
                                                                        {
                                                                            this.renders.amenities(item).map((item) => {
                                                                                return (
                                                                                    <div
                                                                                        className={
                                                                                            cx(Styles.headerSearchContainerFilterDropdownItemExtraItem,
                                                                                                {
                                                                                                    [Styles.headerSearchContainerFilterDropdownItemExtraItemSmall]: this.state.format_small,
                                                                                                })
                                                                                        }>{item}</div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        {
                                            ((this.state.page_size * this.state.page) < this.filters.listings().length) &&
                                            <div onClick={() => {
                                                this.setState({page: this.state.page + 1})
                                            }} style={(this.renders.branding() && this.renders.brandingPrimaryColor()) ? { backgroundColor: this.renders.brandingPrimaryColor()} : {}}
                                                 className={cx(Styles.headerSearchContainerFilterDropdownMore,
                                                {
                                                    [Styles.headerSearchContainerFilterDropdownMorePB]: this.renderPropertyBooster() && !this.renders.branding(),
                                                    [Styles.headerSearchContainerFilterDropdownMoreBB]: this.renderBoostaBostad() && !this.renders.branding(),
                                                    [Styles.headerSearchContainerFilterDropdownMoreYL]: (this.renderYieldlock() || this.renderYieldspotter()) && !this.renders.branding()
                                                })
                                            }>
                                                <img className={Styles.headerSearchContainerFilterDropdownMoreIcon}
                                                     src={require('../../assets/images/plus_sign_white_small.png')}/>
                                            </div>
                                        }
                                    </div>
                                }
                                {
                                    this.state.featured.length > 0 && this.state.brandingSuccess && !this.renders.platformTeaser() && !(this.renderYieldlock() || this.renderYieldspotter()) && (this.state.search === '' && !this.state.beds.first && !this.state.beds.second) &&
                                <div className={Styles.featured}>

                                    <div
                                        style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                        className={Styles.featuredTitle}>
                                        {this.renders.text("item_53")}
                                    </div>
                                    {
                                        this.state.isLoadingFeatured &&
                                        <div className={Styles.featuredLoader}>
                                            <BeatLoader size={15} color={this.renderLoader()} loading={true}/>
                                        </div>
                                    }
                                    {
                                        <AliceCarousel
                                            dotsDisabled={true}
                                            swipeDisabled={true}
                                            autoHeight={true}
                                            buttonsDisabled={true}
                                            ref={(el) => (this['Featured'] = el)}
                                            responsive={{
                                                0: {items: 1},
                                                750: {items: 1},
                                                1050: {items: 1},
                                                1350: {items: 1},
                                            }}
                                        >
                                            {
                                                this.state.featured.sort((a, b) => {
                                                    return b.date - a.date
                                                }).filter((item, index) => {
                                                    return index < 10
                                                }).map((item) => {
                                                    return (
                                                        <BoosterFeatured
                                                            rates={this.state.rates_data}
                                                            market={this.state.market}
                                                            lang={this.state.lang}
                                                            currency={this.state.currency}
                                                            branding={this.renders.branding()}
                                                            branding_primary={this.renders.brandingPrimaryColor()}
                                                            from_channel={this.state.from_channel}
                                                            click_id={this.state.click_id}
                                                            feed_id={this.state.feed_id}
                                                            check_freetext={this.state.check_freetext}
                                                            data={item}/>
                                                    )
                                                })
                                            }
                                        </AliceCarousel>
                                    }
                                    {
                                        <img onClick={() => this['Featured']._slidePrev()}
                                             className={Styles.featuredArrowLeft}
                                             src={require('../../assets/images/AB_arrow_left.png')}/>
                                    }
                                    {
                                        <img onClick={() => this['Featured']._slideNext()}
                                             className={Styles.featuredArrowRight}
                                             src={require('../../assets/images/AB_arrow_right.png')}/>
                                    }
                                </div>
                                }
                                {
                                    this.state.featured.length < 1 && !this.state.isLoadingFeatured && this.state.reseller_banner && this.state.brandingSuccess && !this.renders.platformTeaser() && !(this.renderYieldlock() || this.renderYieldspotter()) && (this.state.search === '' && !this.state.beds.first && !this.state.beds.second) &&
                                    <div className={Styles.promo}>
                                        <a href={"https://" + this.state.reseller_website + "?utm_source=" + salesChannelRegister.get('name')} target={'_blank'}>
                                            <img className={Styles.promoContainerBanner} src={this.state.reseller_banner}/>
                                        </a>
                                    </div>
                                }
                            </div>
                        }
                        {
                            this.renders.platformTeaser() && (this.renderPropertyBooster() || this.renderBoostaBostad()) &&
                            <div className={Styles.headerCalculator}>
                                <Element name="calculator" className="calculatorContainer">
                                    <div id="section1" className={Styles.headerCalculatorContainer}>
                                        <div className={Styles.headerCalculatorContainerOverlay}>
                                            <div className={Styles.cardDonutChartContainer}>
                                                <svg viewBox="0 0 36 36" className={Styles.cardDonutChartContainerCircular}>
                                                    <path className={Styles.cardDonutChartContainerBg}
                                                          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                                    />
                                                    <path className={cx(Styles.cardDonutChartContainerCircle,
                                                        {
                                                            [Styles.cardDonutChartContainerCirclePB]: this.renderPropertyBooster(),
                                                            [Styles.cardDonutChartContainerCircleBB]: this.renderBoostaBostad()
                                                        })
                                                    }
                                                          strokeDasharray={this._renderPercentage(this.state.months) + ", 100"}
                                                          d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                                    />
                                                    <text x="15.5" y="19.35"
                                                          className={Styles.cardDonutChartContainerPercentage}>{this._renderPercentage(this.state.months)}</text>
                                                    <text x="22.5" y="19.00"
                                                          className={Styles.cardDonutChartContainerPercentageSign}>%
                                                    </text>
                                                    <text x="18" y="24.35"
                                                          className={Styles.cardDonutChartContainerTitle}>{this.renders.text("item_52")}</text>
                                                </svg>
                                            </div>
                                            <div className={Styles.cardDonutChartContainerInner}/>
                                            <div className={cx(Styles.tabsCalculatorContainer)}>
                                                <div onClick={() => this.setState({tab: "standard"})} className={
                                                    cx(Styles.tabsCalculatorContainerItem,
                                                        {
                                                            [Styles.tabsCalculatorContainerItemActive]: this.state.tab === "standard",
                                                        })
                                                }>
                                                    {
                                                        window.innerWidth > 1050 &&
                                                    <div className={Styles.tabsCalculatorHeaderTitle}>{this.renders.text("item_42")}<span className={Styles.tabsCalculatorHeaderTitleSmall}>{this.renders.text("item_43")}</span></div>
                                                    }
                                                    {
                                                        window.innerWidth < 1050 &&
                                                        <div className={Styles.tabsCalculatorHeaderTitle}>{this.renders.text("item_42")}<div className={Styles.tabsCalculatorHeaderTitleSmall}>{this.renders.text("item_43")}</div></div>
                                                    }
                                                </div>
                                                <div onClick={() => this.setState({tab: "enterprise"})} className={
                                                    cx(Styles.tabsCalculatorContainerItem,
                                                        {
                                                            [Styles.tabsCalculatorContainerItemActive]: this.state.tab === "enterprise",
                                                        })
                                                }>
                                                    {
                                                        window.innerWidth > 1050 &&
                                                    <div className={Styles.tabsCalculatorHeaderTitle}>{this.renders.text("item_44")}<span className={Styles.tabsCalculatorHeaderTitleSmall}>{this.renders.text("item_45")}</span></div>
                                                    }
                                                    {
                                                        window.innerWidth < 1050 &&
                                                        <div className={Styles.tabsCalculatorHeaderTitle}>{this.renders.text("item_44")}<div className={Styles.tabsCalculatorHeaderTitleSmall}>{this.renders.text("item_45")}</div></div>
                                                    }
                                                </div>
                                            </div>
                                            <div className={Styles.settingsCalculatorContainer}>
                                            <div className={Styles.calculatorDropdownSpend}>
                                                <Dropdown
                                                    options={this.state["spend_" + this.state.market.toLowerCase() + "_" + this.state.lang.toLowerCase()].options}
                                                    error={this.state["spend_" + this.state.market.toLowerCase() + "_" + this.state.lang.toLowerCase()].error}
                                                    placeholder={this.state["spend_" + this.state.market.toLowerCase() + "_" + this.state.lang.toLowerCase()].placeholder}
                                                    value={this.state["spend_" + this.state.market.toLowerCase() + "_" + this.state.lang.toLowerCase()].value}
                                                    onChange={(value) => {
                                                        this.state["spend_" + this.state.market.toLowerCase() + "_" + this.state.lang.toLowerCase()].value = value;
                                                        this.setState({
                                                            ["spend_" + this.state.market.toLowerCase() + "_" + this.state.lang.toLowerCase()]: this.state["spend_" + this.state.market.toLowerCase() + "_" + this.state.lang.toLowerCase()]
                                                        })
                                                    }}
                                                />
                                            </div>
                                                <div className={Styles.sliderValueMobile}>
                                                    <div className={Styles.sliderValueText}>
                                                        {this.renders.text("item_51")}{this.state.months}{this.state.months > 1 ? this.renders.text("item_46") : this.renders.text("item_47")}
                                                    </div>
                                                </div>
                                                <div className={Styles.calculatorSliderMonths}>
                                                    <Slider
                                                        handleStyle={{backgroundColor: this.renderLoader()}}
                                                        trackStyle={{backgroundColor: this.renderLoader()}}
                                                        index={1}
                                                        min={this.state.min_months}
                                                        max={this.state.max_months}
                                                        value={this.state.months}
                                                        onChange={(value) => this._setMonths(value)}
                                                        title={this.renders.text("item_48")}
                                                        titleTwo={window.innerWidth < 1050 ? true : false}
                                                        currency={this.renders.text("item_49")}
                                                        impressions={this._renderLeadsByMonth()}
                                                        handle={this.renderBoostaBostad() ? this._renderHandleBB : this._renderHandlePB}
                                                    />
                                                </div>
                                                    <div className={cx(Styles.sliderContainerInfoTitle,
                                                        {
                                                            [Styles.sliderContainerInfoTitlePB]: this.renderPropertyBooster(),
                                                            [Styles.sliderContainerInfoTitleBB]: this.renderBoostaBostad()
                                                        })
                                                    }>
                                                        {this.renders.text("item_50")}
                                                    </div>
                                                <div className={Styles.sliderValue}>
                                                    <div className={Styles.sliderValueText}>
                                                        {this.renders.text("item_51")}{this.state.months}{this.state.months > 1 ? this.renders.text("item_46") : this.renders.text("item_47")}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Element>
                            </div>
                        }
                    </div>
                </div>
                {
                    (this.state.search === '' && !this.state.beds.first && !this.state.beds.second) && !this.renders.platformTeaser() &&
                    (this.renderYieldlock() || this.renderYieldspotter()) &&
                    <div className={Styles.tabsInfoLeftImageContainer}>
                        <img src={require('../../assets/images/YS_aplusassured_Desktop_EN.png')}
                             className={Styles.tabsInfoLeftImage}/>
                    </div>
                }
                {
                    this.renders.platformTeaser() && this.renders.newsFeed() && this.renderPropertyBooster() &&
                    <div className={Styles.news}>
                      <div className={Styles.newsItems}>
                            <div
                                style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                className={Styles.listingsTitle}>
                                {'> '}{this.renders.text("item_41")}{' <'}
                            </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                 //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340860/internal%20media/PropertyBooster_Cover_2_n4xhhe.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648342412/internal%20media/A78C2102_PB_Brief_Agent_AE_EN_Rev11_S1_gagfpx.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648827944/internal%20media/PB_NewsSlides_INT_EN_Rev1_P2_slscb0.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648827945/internal%20media/PB_NewsSlides_INT_EN_Rev1_P1_ycnkje.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648827945/internal%20media/PB_FunnelSlide_INT_EN_Rev2_gzj9wi.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648831799/internal%20media/PB_NewsSlides_INT_EN_Rev2_P6_eknmnl.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340859/internal%20media/A78C2309_PB_AgentDeck_AE_EN_Rev12_P10_oafiqi.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648342340/internal%20media/A78C2309_PB_AgentDeck_AE_EN_Rev12_P18_rzeo7m.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340858/internal%20media/A78C2309_PB_AgentDeck_AE_EN_Rev12_P2_obt5us.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340858/internal%20media/A78C2309_PB_AgentDeck_AE_EN_Rev12_P8_uun8ho.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648827944/internal%20media/PB_NewsSlides_INT_EN_Rev2_P5_j99rly.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340858/internal%20media/A78C2309_PB_AgentDeck_AE_EN_Rev12_P6_jz67aw.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340859/internal%20media/A78C2309_PB_AgentDeck_AE_EN_Rev12_P9_h9lvjj.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340859/internal%20media/A78C2309_PB_AgentDeck_AE_EN_Rev12_P16_rdeqqc.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340860/internal%20media/PropertyBooster_Cover_3_xnp6cl.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340859/internal%20media/A78C2309_PB_AgentDeck_AE_EN_Rev12_P4_vdvlxl.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340860/internal%20media/PropertyBooster_Cover_8_cr93qp.jpg'} />
                          </div>
                          <div className={Styles.newsContainer}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340860/internal%20media/A78C2802_PB_Flyer_WhatToExpect_AE_EN_Rev1_hr0s4f.jpg'} />
                          </div>
                          <div className={Styles.newsContainer} style={{paddingBottom: 'calc(var(--size-factor) * 0px)'}}>
                              <img onClick={() => {
                                  //window.scrollTo(0, 0);
                              }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1648340860/internal%20media/PropertyBooster_Cover_10_gzzuwq.jpg'} />
                          </div>
                        </div>
                    </div>
                }
                {
                    this.renders.platformTeaser() && this.renders.newsFeed() && this.renderBoostaBostad() && this.props.match.params.lang === 'en' &&
                    <div className={Styles.news}>
                        <div className={Styles.newsItems}>
                            <div
                                style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                className={Styles.listingsTitle}>
                                {'> '}{this.renders.text("item_41")}{' <'}
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333183/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_2_relioz.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333218/internal%20media/BB_BeyondSlide_SE_EN_Rev1_oiox63.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333246/internal%20media/BB_NewsSlides_SE_EN_Rev1_2_ugi30q.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333263/internal%20media/BB_NewsSlides_SE_EN_Rev1_1_obebc8.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333282/internal%20media/BB_FunnelSlide_SE_EN_Rev1_g9tq0c.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333302/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_9_saylva.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333321/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_15_gmuwmd.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333337/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_12_wu59ti.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333354/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_14_hqctsh.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333370/internal%20media/BB_NewsSlides_SE_EN_Rev1_5_hs0y5y.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333385/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_10_hm1gbf.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333399/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_11_oizpnz.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333415/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_3_v9cs9x.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333430/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_13_exhjcl.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333446/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_8_pokdh9.jpg'} />
                            </div>
                            <div className={Styles.newsContainer} style={{paddingBottom: 'calc(var(--size-factor) * 0px)'}}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333461/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_16_lwloo7.jpg'} />
                            </div>
                        </div>
                    </div>
                }
                {
                    this.renders.platformTeaser() && this.renders.newsFeed() && this.renderBoostaBostad() && this.props.match.params.lang === 'sv' &&
                    <div className={Styles.news}>
                        <div className={Styles.newsItems}>
                            <div
                                style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                className={Styles.listingsTitle}>
                                {'> '}{this.renders.text("item_41")}{' <'}
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333565/internal%20media/A79C21401_BB_Covers_SE_SV_Rev1_2_uimm7v.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333592/internal%20media/BB_BeyondSlide_SE_SV_Rev1_kupw3b.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333612/internal%20media/BB_NewsSlides_SE_SV_Rev1_2_ocpmo8.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657334100/internal%20media/BB_NewsSlides_SE_SV_Rev1_1_vpa9y0.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333647/internal%20media/BB_FunnelSlide_SE_SV_Rev1_xz18pm.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1659787974/internal%20media/A79C21401_BB_Covers_SE_SV_Rev1_9_sqtwak.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333682/internal%20media/A79C21401_BB_Covers_SE_SV_Rev1_15_sukuwh.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333697/internal%20media/A79C21401_BB_Covers_SE_SV_Rev1_12_zt39j6.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333720/internal%20media/A79C21401_BB_Covers_SE_SV_Rev1_14_uupopf.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333736/internal%20media/BB_NewsSlides_SE_SV_Rev1_5_egqfjk.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333753/internal%20media/A79C21401_BB_Covers_SE_SV_Rev1_10_bdjsdp.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333769/internal%20media/A79C21401_BB_Covers_SE_SV_Rev1_11_vaj4tv.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333786/internal%20media/A79C21401_BB_Covers_SE_SV_Rev1_3_smpotx.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333801/internal%20media/A79C21401_BB_Covers_SE_SV_Rev1_13_hw3epk.jpg'} />
                            </div>
                            <div className={Styles.newsContainer}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333818/internal%20media/A79C21401_BB_Covers_SE_SV_Rev1_8_swt1tb.jpg'} />
                            </div>
                            <div className={Styles.newsContainer} style={{paddingBottom: 'calc(var(--size-factor) * 0px)'}}>
                                <img onClick={() => {
                                    //window.scrollTo(0, 0);
                                }} className={Styles.newsContainerImage} src={'https://res.cloudinary.com/propertybooster/image/upload/v1657333461/internal%20media/A79C21401_BB_Covers_SE_EN_Rev1_16_lwloo7.jpg'} />
                            </div>
                        </div>
                    </div>
                }
                {
                     this.filters.tags_merged(5) && !this.renders.platformTeaser() && !(this.renderYieldlock() || this.renderYieldspotter()) && (this.state.search === '' && !this.state.beds.first && !this.state.beds.second) &&
                    <div
                        className={Styles.headerTagsContainerFilterDropdownItemExtra}>
                        <div
                            style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                            className={Styles.tagsTitle}>
                            {this.renders.text("item_54")}
                        </div>
                        <div
                            className={Styles.headerTagsContainerFilterDropdownItemExtraInner}>
                            {
                                this.filters.tags_merged().map((item) => {
                                    return (
                                        <div onClick={() => {
                                            this.setState({search: item})
                                        }}
                                            className={Styles.headerTagsContainerFilterDropdownItemExtraItem}>{item}</div>
                                    )
                                })
                            }
                        </div>
                    </div>
                }
                {
                    (this.state.search === '' && !this.state.beds.first && !this.state.beds.second) && !this.renders.platformTeaser() &&
                    <div className={Styles.categories}>
                        {
                            Object.keys(this.state.categories).map((key) => {
                                if (this.state.categories[key].items.length > 3 || this.state.categories[key].loading) {
                                    return (
                                        <div className={Styles.listings}>
                                            <div
                                                style={this.renderYieldlock() || this.renderYieldspotter() ? {color: '#00273A'} : {}}
                                                className={Styles.listingsTitle}>
                                                {'> '}{this.state.categories[key].title}{' <'}
                                            </div>
                                            {
                                                this.state.categories[key].loading &&
                                                <div className={Styles.listingsLoader}>
                                                    <BeatLoader size={25} color={this.renderLoader()} loading={true}/>
                                                </div>
                                            }
                                            {
                                                !this.state.categories[key].loading &&
                                                <AliceCarousel
                                                    dotsDisabled={true}
                                                    swipeDisabled={true}
                                                    autoHeight={true}
                                                    buttonsDisabled={true}
                                                    ref={(el) => (this['Carousel' + key] = el)}
                                                    responsive={{
                                                        0: {items: 1},
                                                        750: {items: 2},
                                                        1050: {items: 3},
                                                        1350: {items: 4},
                                                    }}
                                                >
                                                    {
                                                        this.state.categories[key].items.sort((a, b) => {
                                                            return b.date - a.date
                                                        }).filter((item, index) => {
                                                            return index < 10
                                                        }).map((item) => {
                                                            return (
                                                                <BoosterProperty
                                                                                 rates={this.state.rates_data}
                                                                                 market={this.state.market}
                                                                                 lang={this.state.lang}
                                                                                 currency={this.state.currency}
                                                                                 branding={this.renders.branding()}
                                                                                 branding_primary={this.renders.brandingPrimaryColor()}
                                                                                 data={item}
                                                                                 format_small={this.state.format_small}
                                                                                 from_channel={this.state.from_channel}
                                                                                 click_id={this.state.click_id}
                                                                                 feed_id={this.state.feed_id}
                                                                                 check_freetext={this.state.check_freetext}
                                                                />
                                                            )
                                                        })
                                                    }
                                                </AliceCarousel>
                                            }
                                            {
                                                !this.state.categories[key].loading &&
                                                <img onClick={() => this['Carousel' + key]._slidePrev()}
                                                     className={Styles.listingsArrowLeft}
                                                     src={require('../../assets/images/AB_arrow_left.png')}/>
                                            }
                                            {
                                                !this.state.categories[key].loading &&
                                                <img onClick={() => this['Carousel' + key]._slideNext()}
                                                     className={Styles.listingsArrowRight}
                                                     src={require('../../assets/images/AB_arrow_right.png')}/>
                                            }
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>
                }
                {
                    (this.state.search === '' && !this.state.beds.first && !this.state.beds.second) &&
                    <Footer market={this.state.market} lang={this.state.lang} currency={this.state.currency} branding={this.renders.branding()} branding_primary={this.renders.brandingPrimaryColor()}/>
                }
            </div>
        );
    }
}

export default BoosterList;


// WEBPACK FOOTER //
// ./src/pages/booster-list/component.js